export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  AWSDate: string;
  AWSDateTime: string;
  AWSEmail: string;
  AWSIPAddress: string;
  AWSJSON: string;
  AWSPhone: string;
  AWSTime: string;
  AWSTimestamp: number;
  AWSURL: string;
  Long: number;
};

export type AcceptCustomerInvitation = {
  __typename?: 'AcceptCustomerInvitation';
  successful: Scalars['Boolean'];
};

export type AcceptInvitationInput = {
  force?: InputMaybe<Scalars['Boolean']>;
  invitationCode: Scalars['String'];
};

export type AddDevicesToGroupInput = {
  deviceIds: Array<Scalars['ID']>;
  groupId: Scalars['ID'];
};

export type AllCleaningReports = {
  __typename?: 'AllCleaningReports';
  nodes: Array<CleaningReport>;
  pageInfo: PaginationMetadata;
};

export type AppVersion = {
  __typename?: 'AppVersion';
  minAppVersion: Scalars['String'];
};

export enum AssetPermissionEnum {
  Edit = 'EDIT',
  FullPermission = 'FULL_PERMISSION',
  NoPermission = 'NO_PERMISSION',
  Read = 'READ'
}

export type AssignDeviceGroupsToScopeInput = {
  groupIds: Array<Scalars['ID']>;
  scopeIds: Array<Scalars['ID']>;
};

export type AssignMapGroupsToScopeInput = {
  groupIds: Array<Scalars['ID']>;
  scopeIds: Array<Scalars['ID']>;
};

export type AssignUsersToScopeInput = {
  roleId: Scalars['ID'];
  scopeId: Scalars['ID'];
  userIds: Array<Scalars['ID']>;
};

export type AssignedDevices = {
  __typename?: 'AssignedDevices';
  assetPermission?: Maybe<AssetPermissionEnum>;
  createdAt: Scalars['String'];
  customerId: Scalars['String'];
  id: Scalars['ID'];
  materialNumber: Scalars['String'];
  name: Scalars['String'];
  serialNumber: Scalars['String'];
  type: DeviceTypeName;
  updatedAt: Scalars['String'];
};

export type AssignedDevicesInput = {
  createdAt: Scalars['String'];
  customerId: Scalars['String'];
  id: Scalars['ID'];
  materialNumber: Scalars['String'];
  name: Scalars['String'];
  serialNumber: Scalars['String'];
  type: DeviceTypeName;
  updatedAt: Scalars['String'];
};

export type AssignedMaps = {
  __typename?: 'AssignedMaps';
  assetPermission?: Maybe<AssetPermissionEnum>;
  createdAt: Scalars['String'];
  customerId: Scalars['String'];
  mapId: Scalars['ID'];
  mapType: Scalars['String'];
  materialNumber: Scalars['String'];
  name: Scalars['String'];
  serialNumber: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type AssociateDevicesToMapInput = {
  associatedDevices: Array<AssociatedDevicesInput>;
  id: Scalars['ID'];
};

export type AssociateDevicesToMapResponse = {
  __typename?: 'AssociateDevicesToMapResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type AssociateMapsToGroupInput = {
  id: Scalars['ID'];
  mapIds: Array<Scalars['ID']>;
};

export type AssociateMapsToGroupResponse = {
  __typename?: 'AssociateMapsToGroupResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type AssociatedDevices = {
  __typename?: 'AssociatedDevices';
  materialNumber?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
};

export type AssociatedDevicesInput = {
  materialNumber?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
};

export type BRangeCleaningCommandInput = {
  commandType: BRangeCleaningCommandType;
  materialNumber: Scalars['String'];
  routeIds?: InputMaybe<Array<Scalars['Int']>>;
  routineId?: InputMaybe<Scalars['Int']>;
  serialNumber: Scalars['String'];
};

export enum BRangeCleaningCommandType {
  MissionDriveBackAndCancel = 'MISSION_DRIVE_BACK_AND_CANCEL',
  MissionDriveBackAndSkip = 'MISSION_DRIVE_BACK_AND_SKIP',
  MissionInstinctiveDocking = 'MISSION_INSTINCTIVE_DOCKING',
  MissionPause = 'MISSION_PAUSE',
  MissionResume = 'MISSION_RESUME',
  MissionStop = 'MISSION_STOP',
  StartCleaning = 'START_CLEANING'
}

export type BatteryPack = {
  __typename?: 'BatteryPack';
  active: Scalars['Float'];
  cycleCount: Scalars['Float'];
  fullChargeCapacity: Scalars['Float'];
  id: Scalars['ID'];
  remainingCapacity: Scalars['Float'];
  stateOfCharge: Scalars['Float'];
  status: Scalars['String'];
  temperature: Scalars['Float'];
};

export type BatteryPackInput = {
  active?: InputMaybe<Scalars['Float']>;
  cycleCount?: InputMaybe<Scalars['Float']>;
  fullChargeCapacity?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['ID']>;
  remainingCapacity?: InputMaybe<Scalars['Float']>;
  stateOfCharge?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<Scalars['String']>;
  temperature?: InputMaybe<Scalars['Float']>;
};

export type BatteryPackUpdate = {
  __typename?: 'BatteryPackUpdate';
  active?: Maybe<Scalars['Float']>;
  cycleCount?: Maybe<Scalars['Float']>;
  fullChargeCapacity?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['ID']>;
  remainingCapacity?: Maybe<Scalars['Float']>;
  stateOfCharge?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['String']>;
  temperature?: Maybe<Scalars['Float']>;
};

export enum Cv50Commands {
  Beep = 'BEEP',
  Blink = 'BLINK',
  CleaningProfileDelete = 'CLEANING_PROFILE_DELETE',
  ScheduleCleaningProfileDelete = 'SCHEDULE_CLEANING_PROFILE_DELETE',
  ScheduleCleaningProfileSet = 'SCHEDULE_CLEANING_PROFILE_SET',
  SettingsAutoSideBroomSpeed = 'SETTINGS_AUTO_SIDE_BROOM_SPEED',
  SettingsBatteryTheft = 'SETTINGS_BATTERY_THEFT',
  SettingsBluetooth = 'SETTINGS_BLUETOOTH',
  SettingsCableDetection = 'SETTINGS_CABLE_DETECTION',
  SettingsCarpetDetection = 'SETTINGS_CARPET_DETECTION',
  SettingsCleaningMode = 'SETTINGS_CLEANING_MODE',
  SettingsHmiLanguage = 'SETTINGS_HMI_LANGUAGE',
  SettingsLights = 'SETTINGS_LIGHTS',
  SettingsLock = 'SETTINGS_LOCK',
  SettingsLockcode = 'SETTINGS_LOCKCODE',
  SettingsQuickCleaningMode = 'SETTINGS_QUICK_CLEANING_MODE',
  SettingsReset = 'SETTINGS_RESET',
  SettingsRobotName = 'SETTINGS_ROBOT_NAME',
  SettingsSoundOperating = 'SETTINGS_SOUND_OPERATING',
  SettingsSoundVolume = 'SETTINGS_SOUND_VOLUME',
  SettingsSoundWarning = 'SETTINGS_SOUND_WARNING',
  SettingsTheftProtection = 'SETTINGS_THEFT_PROTECTION',
  SettingsWifiConnect = 'SETTINGS_WIFI_CONNECT',
  SettingsWifiDelete = 'SETTINGS_WIFI_DELETE',
  Update = 'UPDATE',
  UploadLog = 'UPLOAD_LOG',
  UploadMap = 'UPLOAD_MAP'
}

export type CategorySubscriptionsQueryResponse = {
  __typename?: 'CategorySubscriptionsQueryResponse';
  categories: Array<Maybe<NotificationCategoryTypeEnum>>;
};

export type ChangeBluetoothConnectivityInput = {
  enabled: Scalars['Boolean'];
  materialNumber: Scalars['String'];
  serialNumber: Scalars['String'];
};

export type ChangeDeviceLanguage = {
  __typename?: 'ChangeDeviceLanguage';
  newLanguage: DeviceLanguage;
  oldLanguage: DeviceLanguage;
};

export type ChangeDeviceLanguageInput = {
  language: DeviceLanguage;
  materialNumber: Scalars['String'];
  serialNumber: Scalars['String'];
};

export type ChangeDeviceName = {
  __typename?: 'ChangeDeviceName';
  newName: Scalars['String'];
  oldName: Scalars['String'];
};

export type ChangeDeviceNameInput = {
  materialNumber: Scalars['String'];
  name: Scalars['String'];
  serialNumber: Scalars['String'];
};

export type ChangeDevicePin = {
  __typename?: 'ChangeDevicePin';
  successful: Scalars['Boolean'];
};

export type ChangeDevicePinInput = {
  materialNumber: Scalars['String'];
  pin: Scalars['Int'];
  serialNumber: Scalars['String'];
};

export type ChangeDeviceSound = {
  __typename?: 'ChangeDeviceSound';
  successful: Scalars['Boolean'];
};

export type ChangeDeviceSoundInput = {
  materialNumber: Scalars['String'];
  operatingSound?: InputMaybe<Scalars['Boolean']>;
  serialNumber: Scalars['String'];
  volume?: InputMaybe<Scalars['Int']>;
  warningSound?: InputMaybe<Scalars['Boolean']>;
};

export type ChangeFirmwareUpdateMode = {
  __typename?: 'ChangeFirmwareUpdateMode';
  successful: Scalars['Boolean'];
};

export type ChangeFirmwareUpdateModeInput = {
  automatic: Scalars['Boolean'];
  materialNumber: Scalars['String'];
  serialNumber: Scalars['String'];
};

export type ChangePasswordInput = {
  newPassword: Scalars['String'];
  oldPassword: Scalars['String'];
};

export type ChangePasswordResponse = {
  __typename?: 'ChangePasswordResponse';
  code?: Maybe<Scalars['Int']>;
  errorCode?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  errorType?: Maybe<Scalars['String']>;
};

export type ClaimDeviceInput = {
  claimingCode: Scalars['String'];
  deviceGroupIds?: InputMaybe<Array<Scalars['String']>>;
  materialNumber: Scalars['String'];
  serialNumber: Scalars['String'];
};

export type ClaimDeviceSubscription = {
  __typename?: 'ClaimDeviceSubscription';
  customerId?: Maybe<Scalars['String']>;
  dateOfClaim?: Maybe<Scalars['String']>;
  deviceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  isConfirmed?: Maybe<Scalars['Boolean']>;
  materialNumber?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type ClaimDeviceSubscriptionInput = {
  customerId: Scalars['String'];
  dateOfClaim?: InputMaybe<Scalars['String']>;
  deviceId: Scalars['String'];
  id: Scalars['ID'];
  isConfirmed?: InputMaybe<Scalars['Boolean']>;
  materialNumber: Scalars['String'];
  serialNumber: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type ClaimedDevice = {
  __typename?: 'ClaimedDevice';
  customerId: Scalars['String'];
  deviceId: Scalars['String'];
  id: Scalars['ID'];
  materialNumber: Scalars['String'];
  serialNumber: Scalars['String'];
};

export enum ClaimingValidationResultEnum {
  AlreadyClaimed = 'ALREADY_CLAIMED',
  AlreadyClaimedSelf = 'ALREADY_CLAIMED_SELF',
  ClaimingPossible = 'CLAIMING_POSSIBLE',
  Deactivated = 'DEACTIVATED',
  NotFound = 'NOT_FOUND',
  NotSupported = 'NOT_SUPPORTED'
}

export enum CleaningActivityEnum {
  Cleaning = 'CLEANING',
  Exploration = 'EXPLORATION'
}

export enum CleaningActivityTriggerEnum {
  Autonomous = 'AUTONOMOUS',
  Manual = 'MANUAL',
  Scheduled = 'SCHEDULED'
}

export enum CleaningIssueLevelEnum {
  Critical = 'Critical',
  Info = 'Info',
  Major = 'Major',
  Minor = 'Minor'
}

export enum CleaningModeEnum {
  Area = 'AREA',
  Spot = 'SPOT',
  WholeMap = 'WHOLE_MAP'
}

export type CleaningReport = {
  __typename?: 'CleaningReport';
  activity: CleaningActivityEnum;
  activityTrigger: CleaningActivityTriggerEnum;
  cleanedArea: Scalars['Int'];
  cleanedTime: Scalars['Int'];
  cleaningGroupId?: Maybe<Scalars['String']>;
  consumption?: Maybe<CleaningReportConsumption>;
  currentCleaningZone?: Maybe<Scalars['String']>;
  customerId: Scalars['String'];
  deviceDetails: CleaningReportDeviceDetails;
  deviceFirmware: Scalars['String'];
  deviceId: Scalars['String'];
  deviceName: Scalars['String'];
  deviceType: DeviceTypeName;
  doneCleaningZones?: Maybe<Array<Scalars['String']>>;
  endTime?: Maybe<Scalars['String']>;
  general: CleaningReportGeneral;
  id: Scalars['String'];
  issues: Array<CleaningReportIssue>;
  mapGroupName?: Maybe<Scalars['String']>;
  mapId?: Maybe<Scalars['String']>;
  mapInfo?: Maybe<CleaningReportMapInfo>;
  mapName?: Maybe<Scalars['String']>;
  materialNumber: Scalars['String'];
  nextCleaningZone?: Maybe<Scalars['String']>;
  remainingArea: Scalars['Int'];
  remainingCleaningZones?: Maybe<Array<Scalars['String']>>;
  remainingTime: Scalars['Int'];
  reportType: CleaningReportTypeEnum;
  routeCount?: Maybe<Scalars['Int']>;
  routeIndex?: Maybe<Scalars['Int']>;
  schedule?: Maybe<CleaningReportSchedule>;
  scheduleId?: Maybe<Scalars['String']>;
  scope?: Maybe<CleaningScopeEnum>;
  serialNumber: Scalars['String'];
  spotCoordinates?: Maybe<CleaningSpot>;
  startTime: Scalars['String'];
  status: CleaningStatusEnum;
  suctionMode: Scalars['Int'];
};

export type CleaningReportConnection = {
  __typename?: 'CleaningReportConnection';
  nodes: Array<CleaningReport>;
};

export type CleaningReportConnectionInput = {
  nodes: Array<CleaningReportInput>;
};

export type CleaningReportConsumption = {
  __typename?: 'CleaningReportConsumption';
  battery?: Maybe<Scalars['Float']>;
  detergents?: Maybe<Scalars['Float']>;
  water?: Maybe<Scalars['Float']>;
};

export type CleaningReportConsumptionInput = {
  battery?: InputMaybe<Scalars['Float']>;
  detergents?: InputMaybe<Scalars['Float']>;
  water?: InputMaybe<Scalars['Float']>;
};

export type CleaningReportDeviceDetails = {
  __typename?: 'CleaningReportDeviceDetails';
  deviceFirmware?: Maybe<Scalars['String']>;
  deviceName?: Maybe<Scalars['String']>;
  deviceType?: Maybe<DeviceTypeName>;
};

export type CleaningReportDeviceDetailsInput = {
  deviceFirmware?: InputMaybe<Scalars['String']>;
  deviceName?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<DeviceTypeName>;
};

export type CleaningReportGeneral = {
  __typename?: 'CleaningReportGeneral';
  activity?: Maybe<CleaningActivityEnum>;
  activityTrigger?: Maybe<CleaningActivityTriggerEnum>;
  cleanedArea: Scalars['Int'];
  cleanedTime: Scalars['Int'];
  coveredArea?: Maybe<Scalars['Int']>;
  distance?: Maybe<Scalars['Float']>;
  pathCoverage: Scalars['Float'];
  remainingArea?: Maybe<Scalars['Int']>;
  remainingTime?: Maybe<Scalars['Int']>;
  suctionMode?: Maybe<Scalars['Int']>;
  uncleanedArea?: Maybe<Scalars['Int']>;
};

export type CleaningReportGeneralInput = {
  activity?: InputMaybe<CleaningActivityEnum>;
  activityTrigger?: InputMaybe<CleaningActivityTriggerEnum>;
  cleanedArea?: InputMaybe<Scalars['Int']>;
  cleanedTime?: InputMaybe<Scalars['Int']>;
  coveredArea?: InputMaybe<Scalars['Int']>;
  distance?: InputMaybe<Scalars['Float']>;
  pathCoverage?: InputMaybe<Scalars['Float']>;
  remainingArea?: InputMaybe<Scalars['Int']>;
  remainingTime?: InputMaybe<Scalars['Int']>;
  suctionMode?: InputMaybe<Scalars['Int']>;
  uncleanedArea?: InputMaybe<Scalars['Int']>;
};

export type CleaningReportInput = {
  activity?: InputMaybe<CleaningActivityEnum>;
  activityTrigger?: InputMaybe<CleaningActivityTriggerEnum>;
  cleanedArea?: InputMaybe<Scalars['Int']>;
  cleanedTime?: InputMaybe<Scalars['Int']>;
  consumption?: InputMaybe<CleaningReportConsumptionInput>;
  currentCleaningZone?: InputMaybe<Scalars['String']>;
  customerId: Scalars['String'];
  deviceDetails?: InputMaybe<CleaningReportDeviceDetailsInput>;
  deviceFirmware?: InputMaybe<Scalars['String']>;
  deviceId: Scalars['String'];
  deviceName?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<DeviceTypeName>;
  doneCleaningZones?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  endTime?: InputMaybe<Scalars['String']>;
  general?: InputMaybe<CleaningReportGeneralInput>;
  id: Scalars['String'];
  issues?: InputMaybe<Array<CleaningReportIssueInput>>;
  mapGroupName?: InputMaybe<Scalars['String']>;
  mapId?: InputMaybe<Scalars['String']>;
  mapInfo?: InputMaybe<CleaningReportMapInfoInput>;
  mapName?: InputMaybe<Scalars['String']>;
  materialNumber: Scalars['String'];
  nextCleaningZone?: InputMaybe<Scalars['String']>;
  remainingArea?: InputMaybe<Scalars['Int']>;
  remainingCleaningZones?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  remainingTime?: InputMaybe<Scalars['Int']>;
  reportType?: InputMaybe<CleaningReportTypeEnum>;
  routeCount?: InputMaybe<Scalars['Int']>;
  routeIndex?: InputMaybe<Scalars['Int']>;
  schedule?: InputMaybe<CleaningReportScheduleInput>;
  scheduleId?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<CleaningScopeEnum>;
  serialNumber: Scalars['String'];
  spotCoordinates?: InputMaybe<CleaningSpotInput>;
  startTime?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<CleaningStatusEnum>;
  suctionMode?: InputMaybe<Scalars['Int']>;
};

export type CleaningReportIssue = {
  __typename?: 'CleaningReportIssue';
  code: Scalars['String'];
  coordinateX: Scalars['Int'];
  coordinateY: Scalars['Int'];
  level: CleaningIssueLevelEnum;
  timestamp: Scalars['String'];
};

export type CleaningReportIssueInput = {
  code?: InputMaybe<Scalars['String']>;
  coordinateX?: InputMaybe<Scalars['Int']>;
  coordinateY?: InputMaybe<Scalars['Int']>;
  level?: InputMaybe<CleaningIssueLevelEnum>;
  timestamp?: InputMaybe<Scalars['String']>;
};

export type CleaningReportIssueUpdate = {
  __typename?: 'CleaningReportIssueUpdate';
  code?: Maybe<Scalars['String']>;
  coordinateX?: Maybe<Scalars['Int']>;
  coordinateY?: Maybe<Scalars['Int']>;
  level?: Maybe<CleaningIssueLevelEnum>;
  timestamp?: Maybe<Scalars['String']>;
};

export type CleaningReportMap = {
  __typename?: 'CleaningReportMap';
  id: Scalars['ID'];
  url: Scalars['String'];
};

export type CleaningReportMapInfo = {
  __typename?: 'CleaningReportMapInfo';
  cleaningGroupId?: Maybe<Scalars['String']>;
  mapGroupName?: Maybe<Scalars['String']>;
  mapId?: Maybe<Scalars['String']>;
  mapName?: Maybe<Scalars['String']>;
  repeatPathId?: Maybe<Scalars['String']>;
  routineId?: Maybe<Scalars['String']>;
};

export type CleaningReportMapInfoInput = {
  cleaningGroupId?: InputMaybe<Scalars['String']>;
  mapGroupName?: InputMaybe<Scalars['String']>;
  mapId?: InputMaybe<Scalars['String']>;
  mapName?: InputMaybe<Scalars['String']>;
  repeatPathId?: InputMaybe<Scalars['String']>;
  routineId?: InputMaybe<Scalars['String']>;
};

export type CleaningReportSchedule = {
  __typename?: 'CleaningReportSchedule';
  cleaningZones?: Maybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  mapId: Scalars['ID'];
  repetition: CleaningScheduleRepetitionEnum;
  startTime: Scalars['String'];
  suction: Scalars['Int'];
  weekdays: Array<Scalars['Int']>;
};

export type CleaningReportScheduleInput = {
  cleaningZones?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['ID']>;
  mapId?: InputMaybe<Scalars['ID']>;
  repetition?: InputMaybe<CleaningScheduleRepetitionEnum>;
  startTime?: InputMaybe<Scalars['String']>;
  suction?: InputMaybe<Scalars['Int']>;
  weekdays?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type CleaningReportScheduleUpdate = {
  __typename?: 'CleaningReportScheduleUpdate';
  cleaningZones?: Maybe<Array<Scalars['String']>>;
  id?: Maybe<Scalars['ID']>;
  mapId?: Maybe<Scalars['ID']>;
  repetition?: Maybe<CleaningScheduleRepetitionEnum>;
  startTime?: Maybe<Scalars['String']>;
  suction?: Maybe<Scalars['Int']>;
  weekdays?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type CleaningReportTimeFilter = {
  from?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
};

export enum CleaningReportTypeEnum {
  Route = 'ROUTE',
  Routine = 'ROUTINE',
  RoutineRoute = 'ROUTINE_ROUTE'
}

export type CleaningReportUpdate = {
  __typename?: 'CleaningReportUpdate';
  activity?: Maybe<CleaningActivityEnum>;
  activityTrigger?: Maybe<CleaningActivityTriggerEnum>;
  cleanedArea?: Maybe<Scalars['Int']>;
  cleanedTime?: Maybe<Scalars['Int']>;
  cleaningGroupId?: Maybe<Scalars['String']>;
  consumption?: Maybe<CleaningReportConsumption>;
  currentCleaningZone?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['String']>;
  deviceDetails?: Maybe<CleaningReportDeviceDetails>;
  deviceFirmware?: Maybe<Scalars['String']>;
  deviceId?: Maybe<Scalars['String']>;
  deviceName?: Maybe<Scalars['String']>;
  deviceType?: Maybe<DeviceTypeName>;
  doneCleaningZones?: Maybe<Array<Maybe<Scalars['String']>>>;
  endTime?: Maybe<Scalars['String']>;
  general?: Maybe<CleaningReportUpdateGeneral>;
  id?: Maybe<Scalars['String']>;
  issues?: Maybe<Array<CleaningReportIssue>>;
  mapGroupName?: Maybe<Scalars['String']>;
  mapId?: Maybe<Scalars['String']>;
  mapInfo?: Maybe<CleaningReportMapInfo>;
  mapName?: Maybe<Scalars['String']>;
  materialNumber?: Maybe<Scalars['String']>;
  nextCleaningZone?: Maybe<Scalars['String']>;
  remainingArea?: Maybe<Scalars['Int']>;
  remainingCleaningZones?: Maybe<Array<Maybe<Scalars['String']>>>;
  remainingTime?: Maybe<Scalars['Int']>;
  reportType?: Maybe<CleaningReportTypeEnum>;
  routeCount?: Maybe<Scalars['Int']>;
  routeIndex?: Maybe<Scalars['Int']>;
  schedule?: Maybe<CleaningReportScheduleUpdate>;
  scheduleId?: Maybe<Scalars['String']>;
  scope?: Maybe<CleaningScopeEnum>;
  serialNumber?: Maybe<Scalars['String']>;
  spotCoordinates?: Maybe<CleaningSpot>;
  startTime?: Maybe<Scalars['String']>;
  status?: Maybe<CleaningStatusEnum>;
  suctionMode?: Maybe<Scalars['Int']>;
};

export type CleaningReportUpdateGeneral = {
  __typename?: 'CleaningReportUpdateGeneral';
  activity?: Maybe<CleaningActivityEnum>;
  activityTrigger?: Maybe<CleaningActivityTriggerEnum>;
  cleanedArea?: Maybe<Scalars['Int']>;
  cleanedTime?: Maybe<Scalars['Int']>;
  coveredArea?: Maybe<Scalars['Int']>;
  distance?: Maybe<Scalars['Float']>;
  pathCoverage?: Maybe<Scalars['Float']>;
  remainingArea?: Maybe<Scalars['Int']>;
  remainingTime?: Maybe<Scalars['Int']>;
  suctionMode?: Maybe<Scalars['Int']>;
  uncleanedArea?: Maybe<Scalars['Int']>;
};

export type CleaningSchedule = {
  __typename?: 'CleaningSchedule';
  active: Scalars['Boolean'];
  cleaningMode?: Maybe<CleaningModeEnum>;
  cleaningZones?: Maybe<Array<Scalars['String']>>;
  deviceId: Scalars['String'];
  deviceName: Scalars['String'];
  id: Scalars['ID'];
  lastExecution?: Maybe<Scalars['String']>;
  mapGroupName?: Maybe<Scalars['String']>;
  mapId: Scalars['String'];
  mapName: Scalars['String'];
  repetition: CleaningScheduleRepetitionEnum;
  startTime: Scalars['String'];
  suction: CleaningSuctionEnum;
  weekdays: Array<Scalars['Int']>;
};

export type CleaningScheduleConnection = {
  __typename?: 'CleaningScheduleConnection';
  nodes: Array<CleaningSchedule>;
};

export type CleaningScheduleInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  cleaningMode?: InputMaybe<CleaningModeEnum>;
  cleaningZones?: InputMaybe<Array<Scalars['String']>>;
  customerId: Scalars['String'];
  deviceId?: InputMaybe<Scalars['String']>;
  deviceName?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  lastExecution?: InputMaybe<Scalars['String']>;
  mapGroupName?: InputMaybe<Scalars['String']>;
  mapId: Scalars['String'];
  mapName?: InputMaybe<Scalars['String']>;
  materialNumber: Scalars['String'];
  mode?: InputMaybe<Scalars['String']>;
  repetition?: InputMaybe<CleaningScheduleRepetitionEnum>;
  serialNumber: Scalars['String'];
  startTime?: InputMaybe<Scalars['String']>;
  suction?: InputMaybe<CleaningSuctionEnum>;
  weekdays?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type CleaningScheduleOccurrence = {
  __typename?: 'CleaningScheduleOccurrence';
  cleaningMode?: Maybe<CleaningModeEnum>;
  cleaningZones?: Maybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  map?: Maybe<Map>;
  route?: Maybe<Route>;
  routine?: Maybe<Routine>;
  rrule: Scalars['String'];
  scheduleId: Scalars['ID'];
  scheduleName: Scalars['String'];
  startDate: Scalars['String'];
  suction?: Maybe<CleaningSuctionEnum>;
};

export enum CleaningScheduleRepetitionEnum {
  Daily = 'DAILY',
  OneTime = 'ONE_TIME',
  Weekly = 'WEEKLY'
}

export type CleaningScheduleUpdate = {
  __typename?: 'CleaningScheduleUpdate';
  active?: Maybe<Scalars['Boolean']>;
  cleaningMode?: Maybe<CleaningModeEnum>;
  cleaningZones?: Maybe<Array<Scalars['String']>>;
  customerId?: Maybe<Scalars['String']>;
  deviceId?: Maybe<Scalars['String']>;
  deviceName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  lastExecution?: Maybe<Scalars['String']>;
  mapGroupName?: Maybe<Scalars['String']>;
  mapId?: Maybe<Scalars['String']>;
  mapName?: Maybe<Scalars['String']>;
  materialNumber?: Maybe<Scalars['String']>;
  mode?: Maybe<Scalars['String']>;
  repetition?: Maybe<CleaningScheduleRepetitionEnum>;
  serialNumber?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
  suction?: Maybe<CleaningSuctionEnum>;
  weekdays?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type CleaningScheduleV2 = {
  __typename?: 'CleaningScheduleV2';
  cleaningMode?: Maybe<CleaningModeEnum>;
  cleaningZones?: Maybe<Array<Scalars['String']>>;
  createdAt: Scalars['String'];
  customerId: Scalars['String'];
  deviceId: Scalars['ID'];
  deviceName: Scalars['String'];
  firstExecution?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastExecution?: Maybe<Scalars['String']>;
  mapGroupName?: Maybe<Scalars['String']>;
  mapId?: Maybe<Scalars['ID']>;
  mapName?: Maybe<Scalars['String']>;
  materialNumber: Scalars['String'];
  name: Scalars['String'];
  routeId?: Maybe<Scalars['ID']>;
  routineId?: Maybe<Scalars['ID']>;
  rrule: Scalars['String'];
  serialNumber: Scalars['String'];
  status: ScheduleStatus;
  subscriptionMode?: Maybe<SubscriptionMode>;
  suction: CleaningSuctionEnum;
  type: ScheduleType;
  updatedAt?: Maybe<Scalars['String']>;
};

export type CleaningScheduleV2Connection = {
  __typename?: 'CleaningScheduleV2Connection';
  nodes: Array<CleaningScheduleV2>;
  pageInfo: PageInfo;
};

export type CleaningScheduleV2Input = {
  cleaningMode?: InputMaybe<CleaningModeEnum>;
  cleaningZones?: InputMaybe<Array<Scalars['String']>>;
  createdAt: Scalars['String'];
  customerId: Scalars['String'];
  deviceId: Scalars['ID'];
  deviceName: Scalars['String'];
  firstExecution?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  lastExecution?: InputMaybe<Scalars['String']>;
  mapGroupName?: InputMaybe<Scalars['String']>;
  mapId?: InputMaybe<Scalars['ID']>;
  mapName?: InputMaybe<Scalars['String']>;
  materialNumber: Scalars['String'];
  name: Scalars['String'];
  routeId?: InputMaybe<Scalars['ID']>;
  routineId?: InputMaybe<Scalars['ID']>;
  rrule: Scalars['String'];
  serialNumber: Scalars['String'];
  status: ScheduleStatus;
  subscriptionMode: SubscriptionMode;
  suction: CleaningSuctionEnum;
  type: ScheduleType;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type CleaningScheduleV2Order = {
  direction: OrderDirection;
  field: CleaningScheduleV2OrderField;
};

export enum CleaningScheduleV2OrderField {
  CreatedAt = 'CREATED_AT'
}

export enum CleaningScopeEnum {
  Area = 'AREA',
  Spot = 'SPOT',
  WholeMap = 'WHOLE_MAP'
}

export type CleaningSpot = {
  __typename?: 'CleaningSpot';
  x1: Scalars['Float'];
  x2: Scalars['Float'];
  xStart: Scalars['Float'];
  y1: Scalars['Float'];
  y2: Scalars['Float'];
  yStart: Scalars['Float'];
};

export type CleaningSpotInput = {
  x1: Scalars['Float'];
  x2: Scalars['Float'];
  xStart: Scalars['Float'];
  y1: Scalars['Float'];
  y2: Scalars['Float'];
  yStart: Scalars['Float'];
};

export enum CleaningStatusEnum {
  Canceled = 'CANCELED',
  Failed = 'FAILED',
  Finished = 'FINISHED',
  Interrupted = 'INTERRUPTED',
  Unknown = 'UNKNOWN',
  Working = 'WORKING'
}

export enum CleaningSuctionEnum {
  Boost = 'BOOST',
  Eco = 'ECO',
  Normal = 'NORMAL'
}

export type CloneMapInput = {
  id: Scalars['ID'];
  newId?: InputMaybe<Scalars['ID']>;
  newName?: InputMaybe<Scalars['String']>;
};

export type CloneMapResponse = {
  __typename?: 'CloneMapResponse';
  mapId?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
  uuid?: Maybe<Scalars['String']>;
};

export type Command = {
  data: CommandData;
  type: Cv50Commands;
};

export type CommandData = {
  active?: InputMaybe<Scalars['Boolean']>;
  ap_creds?: InputMaybe<Scalars['String']>;
  cleaningMode?: InputMaybe<Scalars['Int']>;
  cleaningZones?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  code?: InputMaybe<Scalars['Int']>;
  confirm?: InputMaybe<Scalars['Int']>;
  firmware?: InputMaybe<Scalars['Int']>;
  hmiLanguage?: InputMaybe<Scalars['String']>;
  mapId?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<CleaningSuctionEnum>;
  name?: InputMaybe<Scalars['String']>;
  preset?: InputMaybe<Scalars['String']>;
  repetition?: InputMaybe<CleaningScheduleRepetitionEnum>;
  robotName?: InputMaybe<Scalars['String']>;
  scheduleId?: InputMaybe<Scalars['String']>;
  settings?: InputMaybe<Scalars['Int']>;
  soundVolume?: InputMaybe<Scalars['Int']>;
  spot?: InputMaybe<CleaningSpotInput>;
  ssid?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Int']>;
  weekDays?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type CommandDetail = {
  __typename?: 'CommandDetail';
  data?: Maybe<CommandDetailData>;
  type?: Maybe<Cv50Commands>;
};

export type CommandDetailData = {
  __typename?: 'CommandDetailData';
  active?: Maybe<Scalars['Boolean']>;
  cleaningMode?: Maybe<Scalars['Int']>;
  cleaningZones?: Maybe<Array<Maybe<Scalars['String']>>>;
  code?: Maybe<Scalars['Int']>;
  confirm?: Maybe<Scalars['Int']>;
  firmware?: Maybe<Scalars['Int']>;
  mapId?: Maybe<Scalars['String']>;
  mode?: Maybe<CleaningSuctionEnum>;
  name?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  preset?: Maybe<Scalars['String']>;
  repetition?: Maybe<CleaningScheduleRepetitionEnum>;
  robotName?: Maybe<Scalars['String']>;
  scheduleId?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Int']>;
  soundVolume?: Maybe<Scalars['Int']>;
  spot?: Maybe<CleaningSpot>;
  ssid?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
  weekDays?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type CommandDetailDataInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  cleaningMode?: InputMaybe<Scalars['Int']>;
  cleaningZones?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  code?: InputMaybe<Scalars['Int']>;
  confirm?: InputMaybe<Scalars['Int']>;
  firmware?: InputMaybe<Scalars['Int']>;
  hmiLanguage?: InputMaybe<Scalars['String']>;
  mapId?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<CleaningSuctionEnum>;
  name?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  preset?: InputMaybe<Scalars['String']>;
  repetition?: InputMaybe<CleaningScheduleRepetitionEnum>;
  robotName?: InputMaybe<Scalars['String']>;
  scheduleId?: InputMaybe<Scalars['String']>;
  settings?: InputMaybe<Scalars['Int']>;
  soundVolume?: InputMaybe<Scalars['Int']>;
  spot?: InputMaybe<CleaningSpotInput>;
  ssid?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Int']>;
  weekDays?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type CommandDetailInput = {
  data?: InputMaybe<CommandDetailDataInput>;
  type?: InputMaybe<Cv50Commands>;
};

export type CommandSendInput = {
  command: Command;
  deviceId: Scalars['String'];
};

export type CommandStatus = {
  __typename?: 'CommandStatus';
  createdAt?: Maybe<Scalars['String']>;
  details?: Maybe<CommandDetail>;
  executionId: Scalars['String'];
  status?: Maybe<CommandStatusEnum>;
  statusDetail?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  validationError?: Maybe<Scalars['String']>;
};

export type CommandStatusConnection = {
  __typename?: 'CommandStatusConnection';
  nodes: Array<CommandStatus>;
};

export type CommandStatusConnectionInput = {
  nodes: Array<CommandStatusInput>;
};

export enum CommandStatusEnum {
  Canceled = 'CANCELED',
  Failed = 'FAILED',
  Queued = 'QUEUED',
  Requested = 'REQUESTED',
  Succeeded = 'SUCCEEDED'
}

export type CommandStatusInput = {
  createdAt?: InputMaybe<Scalars['String']>;
  details?: InputMaybe<CommandDetailInput>;
  executionId: Scalars['String'];
  status?: InputMaybe<CommandStatusEnum>;
  statusDetail?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type CompanyOnboarding = {
  type: Scalars['String'];
};

export type CompanyOnboardingInput = {
  city?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  customerNumber?: InputMaybe<Scalars['String']>;
  district?: InputMaybe<Scalars['String']>;
  houseNumber?: InputMaybe<Scalars['String']>;
  invitationCode?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  street2?: InputMaybe<Scalars['String']>;
  type: CompanyOnboardingInputEnum;
  zipCode?: InputMaybe<Scalars['String']>;
};

export enum CompanyOnboardingInputEnum {
  CompanyDetails = 'COMPANY_DETAILS',
  InvitationCode = 'INVITATION_CODE'
}

export type ConnectedCustomerInvitation = {
  __typename?: 'ConnectedCustomerInvitation';
  nodes: Array<CustomerInvitation>;
};

export type CreateCustomRoleInput = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  permissions: RolePermissionsInput;
  scopeId: Scalars['ID'];
};

export type CreateDeviceGroupInput = {
  deviceIds?: InputMaybe<Array<Scalars['ID']>>;
  name: Scalars['String'];
  scopeIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type CreateInvitationInput = {
  roleId?: InputMaybe<Scalars['String']>;
  scopeId?: InputMaybe<Scalars['String']>;
  secondsValid?: InputMaybe<Scalars['Int']>;
};

export type CreateMapGroupInput = {
  mapIds?: InputMaybe<Array<Scalars['ID']>>;
  name: Scalars['String'];
  scopeIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type CreateScheduleInput = {
  cleaningZones?: InputMaybe<Array<Scalars['String']>>;
  mapId?: InputMaybe<Scalars['ID']>;
  materialNumber: Scalars['String'];
  name: Scalars['String'];
  routeId?: InputMaybe<Scalars['ID']>;
  routineId?: InputMaybe<Scalars['ID']>;
  rrule: Scalars['String'];
  serialNumber: Scalars['String'];
  suction?: InputMaybe<CleaningSuctionEnum>;
};

export type CreateScopeInput = {
  deviceGroupIds?: InputMaybe<Array<Scalars['ID']>>;
  mapGroupIds?: InputMaybe<Array<Scalars['ID']>>;
  memberships?: InputMaybe<Array<MembershipInput>>;
  name: Scalars['String'];
};

export type CreateScopeResponse = {
  __typename?: 'CreateScopeResponse';
  createdAt: Scalars['String'];
  customerId: Scalars['String'];
  deviceGroups: Array<ScopeDeviceGroup>;
  id: Scalars['ID'];
  isEMScope: Scalars['Boolean'];
  isGlobalScope: Scalars['Boolean'];
  mapGroups: Array<ScopeMapGroup>;
  memberships: Array<ScopeMembership>;
  name: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type CustomRole = {
  __typename?: 'CustomRole';
  createdAt: Scalars['String'];
  customerId: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isReadOnly: Scalars['Boolean'];
  name: Scalars['String'];
  permissions: Permissions;
  scopeId: Scalars['ID'];
  scopeName: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type Customer = {
  __typename?: 'Customer';
  customerId: Scalars['String'];
};

export type CustomerInformation = {
  __typename?: 'CustomerInformation';
  id: Scalars['ID'];
  name: Scalars['String'];
  users: Array<CustomerUser>;
};

export type CustomerInvitation = {
  __typename?: 'CustomerInvitation';
  createdAt: Scalars['String'];
  customerId: Scalars['String'];
  id: Scalars['ID'];
  invitationCode: Scalars['String'];
  roleId?: Maybe<Scalars['String']>;
  scopeId?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
  validUntil?: Maybe<Scalars['String']>;
};

export type CustomerUser = {
  __typename?: 'CustomerUser';
  email: Scalars['String'];
  firstname: Scalars['String'];
  id: Scalars['ID'];
  isAppUser: Scalars['Boolean'];
  lastname: Scalars['String'];
};

export type DeleteCustomRoleInput = {
  roleId: Scalars['ID'];
};

export type DeleteDeviceGroupInput = {
  id: Scalars['ID'];
};

export type DeleteMapGroupInput = {
  id: Scalars['ID'];
};

export type DeleteMapGroupResponse = {
  __typename?: 'DeleteMapGroupResponse';
  success: Scalars['Boolean'];
};

export type DeleteMapInput = {
  mapId: Scalars['ID'];
};

export type DeleteMapResponse = {
  __typename?: 'DeleteMapResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteScheduleInput = {
  applyToFollowing?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  occurrence?: InputMaybe<Scalars['String']>;
};

export type DeleteScopeInput = {
  scopeId: Scalars['ID'];
};

export type Device = {
  __typename?: 'Device';
  cleaningReports?: Maybe<CleaningReportConnection>;
  cleaningSchedules?: Maybe<CleaningScheduleConnection>;
  commands?: Maybe<CommandStatusConnection>;
  createdAt: Scalars['String'];
  currentCleaningReport?: Maybe<CleaningReport>;
  customerId: Scalars['String'];
  firmwareDetail?: Maybe<DeviceFirmwareDetail>;
  id: Scalars['ID'];
  lastCleaningReport?: Maybe<CleaningReport>;
  lastOnline: Scalars['String'];
  maps?: Maybe<DeviceMap>;
  materialNumber: Scalars['String'];
  name: Scalars['String'];
  nextScheduledTask?: Maybe<NextCleaningSchedule>;
  notifications?: Maybe<NotificationConnectionWithoutPaginationSettings>;
  permission?: Maybe<UserAssetPermission>;
  producedRobotId: Scalars['String'];
  serialNumber: Scalars['String'];
  settings?: Maybe<DeviceSettings>;
  state?: Maybe<DeviceState>;
  type: DeviceTypeName;
  updateAvailable: Scalars['Boolean'];
  updatedAt: Scalars['String'];
  wifiDetail?: Maybe<DeviceWifiNetworkDetail>;
};

export type DeviceActions = {
  __typename?: 'DeviceActions';
  canAdd: Scalars['Boolean'];
  mustSelectScope: Scalars['Boolean'];
};

export type DeviceCellularStatus = {
  __typename?: 'DeviceCellularStatus';
  cid: Scalars['Int'];
  iccid: Scalars['String'];
  imei: Scalars['String'];
  imsi: Scalars['String'];
  mcc: Scalars['Int'];
  mnc: Scalars['Int'];
  ss: Scalars['Int'];
  ta: Scalars['Int'];
  tac: Scalars['Int'];
};

export type DeviceCellularStatusInput = {
  cid?: InputMaybe<Scalars['Int']>;
  iccid?: InputMaybe<Scalars['String']>;
  imei?: InputMaybe<Scalars['String']>;
  imsi?: InputMaybe<Scalars['String']>;
  mcc?: InputMaybe<Scalars['Int']>;
  mnc?: InputMaybe<Scalars['Int']>;
  ss?: InputMaybe<Scalars['Int']>;
  ta?: InputMaybe<Scalars['Int']>;
  tac?: InputMaybe<Scalars['Int']>;
};

export type DeviceCellularStatusUpdate = {
  __typename?: 'DeviceCellularStatusUpdate';
  cid?: Maybe<Scalars['Int']>;
  iccid?: Maybe<Scalars['String']>;
  imei?: Maybe<Scalars['String']>;
  imsi?: Maybe<Scalars['String']>;
  mcc?: Maybe<Scalars['Int']>;
  mnc?: Maybe<Scalars['Int']>;
  ss?: Maybe<Scalars['Int']>;
  ta?: Maybe<Scalars['Int']>;
  tac?: Maybe<Scalars['Int']>;
};

export type DeviceConnection = {
  __typename?: 'DeviceConnection';
  nodes: Array<Device>;
  pageInfo: PaginationMetadata;
};

export type DeviceFirmwareDetail = {
  __typename?: 'DeviceFirmwareDetail';
  currentVersion: Scalars['String'];
  lastUpdated: Scalars['String'];
};

export type DeviceFirmwareDetailInput = {
  currentVersion?: InputMaybe<Scalars['String']>;
  lastUpdated?: InputMaybe<Scalars['String']>;
};

export type DeviceFirmwareDetailUpdate = {
  __typename?: 'DeviceFirmwareDetailUpdate';
  currentVersion?: Maybe<Scalars['String']>;
  lastUpdated?: Maybe<Scalars['String']>;
};

export type DeviceFirmwareUpdateSubscription = {
  __typename?: 'DeviceFirmwareUpdateSubscription';
  customerId?: Maybe<Scalars['String']>;
  deviceId?: Maybe<Scalars['String']>;
  firmwareReleaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  materialNumber?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type DeviceFirmwareUpdateSubscriptionInput = {
  customerId: Scalars['String'];
  deviceId?: InputMaybe<Scalars['String']>;
  firmwareReleaseId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  materialNumber?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type DeviceGroup = {
  __typename?: 'DeviceGroup';
  createdAt: Scalars['String'];
  customerId: Scalars['String'];
  devices: Array<AssignedDevices>;
  id: Scalars['ID'];
  name: Scalars['String'];
  permission?: Maybe<UserAssetPermission>;
  updatedAt: Scalars['String'];
};

export type DeviceGroupActions = {
  __typename?: 'DeviceGroupActions';
  canAdd: Scalars['Boolean'];
  mustSelectScope: Scalars['Boolean'];
};

export type DeviceGroupSubscriptionInput = {
  createdAt?: InputMaybe<Scalars['String']>;
  customerId?: InputMaybe<Scalars['String']>;
  devices?: InputMaybe<Array<InputMaybe<AssignedDevicesInput>>>;
  id: Scalars['ID'];
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type DeviceGroupUpdate = {
  __typename?: 'DeviceGroupUpdate';
  createdAt?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['String']>;
  devices?: Maybe<Array<Maybe<AssignedDevices>>>;
  id?: Maybe<Scalars['ID']>;
  mode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type DeviceGroups = {
  __typename?: 'DeviceGroups';
  nodes: Array<DeviceGroup>;
  pageInfo: PaginationMetadata;
};

export type DeviceInput = {
  createdAt?: InputMaybe<Scalars['String']>;
  currentCleaningReport?: InputMaybe<CleaningReportInput>;
  customerId?: InputMaybe<Scalars['String']>;
  firmwareDetail?: InputMaybe<DeviceFirmwareDetailInput>;
  id?: InputMaybe<Scalars['ID']>;
  lastCleaningReport?: InputMaybe<CleaningReportInput>;
  lastOnline?: InputMaybe<Scalars['String']>;
  materialNumber: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  nextScheduledTask?: InputMaybe<NextCleaningScheduleInput>;
  producedRobotId?: InputMaybe<Scalars['String']>;
  serialNumber: Scalars['String'];
  settings?: InputMaybe<DeviceSettingsInput>;
  state?: InputMaybe<DeviceStateInput>;
  type?: InputMaybe<DeviceTypeName>;
  updateAvailable?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['String']>;
  wifiDetail?: InputMaybe<DeviceWifiNetworkDetailInput>;
};

export enum DeviceLanguage {
  Ar = 'ar',
  Bg = 'bg',
  Cs = 'cs',
  Da = 'da',
  De = 'de',
  El = 'el',
  En = 'en',
  Es = 'es',
  Et = 'et',
  Fi = 'fi',
  Fr = 'fr',
  Hr = 'hr',
  Hu = 'hu',
  It = 'it',
  Ja = 'ja',
  Ko = 'ko',
  Lv = 'lv',
  Nl = 'nl',
  No = 'no',
  Pl = 'pl',
  Pt = 'pt',
  Ro = 'ro',
  Ru = 'ru',
  Sk = 'sk',
  Sl = 'sl',
  Sr = 'sr',
  Sv = 'sv',
  Tr = 'tr',
  Uk = 'uk',
  Zh = 'zh'
}

export type DeviceLocation = {
  __typename?: 'DeviceLocation';
  coordinateT?: Maybe<Scalars['Float']>;
  coordinateX: Scalars['Float'];
  coordinateY: Scalars['Float'];
  lastUpdated: Scalars['String'];
  mapId?: Maybe<Scalars['String']>;
};

export type DeviceLocationInput = {
  coordinateX?: InputMaybe<Scalars['Float']>;
  coordinateY?: InputMaybe<Scalars['Float']>;
  deviceId?: InputMaybe<Scalars['ID']>;
  lastUpdated?: InputMaybe<Scalars['String']>;
  mapId?: InputMaybe<Scalars['String']>;
};

export type DeviceLocationUpdate = {
  __typename?: 'DeviceLocationUpdate';
  coordinateX?: Maybe<Scalars['Float']>;
  coordinateY?: Maybe<Scalars['Float']>;
  deviceId?: Maybe<Scalars['ID']>;
  lastUpdated?: Maybe<Scalars['String']>;
  mapId?: Maybe<Scalars['String']>;
};

export type DeviceMap = {
  __typename?: 'DeviceMap';
  nodes: Array<Map>;
};

export type DeviceMapLocation = {
  __typename?: 'DeviceMapLocation';
  coordinateT?: Maybe<Scalars['Float']>;
  coordinateX: Scalars['Float'];
  coordinateY: Scalars['Float'];
  deviceId: Scalars['String'];
  mapId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['String'];
};

export type DeviceMapLocationConnection = {
  __typename?: 'DeviceMapLocationConnection';
  history: Array<DeviceMapLocation>;
  latestLocation?: Maybe<DeviceMapLocation>;
  pageInfo: DeviceMapLocationPageInfo;
};

export type DeviceMapLocationPageInfo = {
  __typename?: 'DeviceMapLocationPageInfo';
  lastUpdatedAt: Scalars['String'];
  limit: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type DeviceMapPositionInput = {
  coordinateT?: InputMaybe<Scalars['Float']>;
  coordinateX?: InputMaybe<Scalars['Float']>;
  coordinateY?: InputMaybe<Scalars['Float']>;
  deviceId?: InputMaybe<Scalars['ID']>;
  lastUpdated?: InputMaybe<Scalars['String']>;
  mapId?: InputMaybe<Scalars['String']>;
  materialNumber?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
};

export type DeviceMapPositionUpdate = {
  __typename?: 'DeviceMapPositionUpdate';
  coordinateT?: Maybe<Scalars['Float']>;
  coordinateX?: Maybe<Scalars['Float']>;
  coordinateY?: Maybe<Scalars['Float']>;
  deviceId?: Maybe<Scalars['ID']>;
  lastUpdated?: Maybe<Scalars['String']>;
  mapId?: Maybe<Scalars['String']>;
  materialNumber?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
};

export type DeviceMcuInfo = {
  __typename?: 'DeviceMcuInfo';
  machineState: DeviceStateEnum;
  mapCount: Scalars['Int'];
  totalCleaningTime: Scalars['Int'];
  totalOperation: Scalars['Int'];
  usedStorage: Scalars['Int'];
};

export type DeviceMcuInfoInput = {
  machineState?: InputMaybe<DeviceStateEnum>;
  mapCount?: InputMaybe<Scalars['Int']>;
  totalCleaningTime?: InputMaybe<Scalars['Int']>;
  totalOperation?: InputMaybe<Scalars['Int']>;
  usedStorage?: InputMaybe<Scalars['Int']>;
};

export type DeviceMcuInfoUpdate = {
  __typename?: 'DeviceMcuInfoUpdate';
  machineState?: Maybe<DeviceStateEnum>;
  mapCount?: Maybe<Scalars['Int']>;
  totalCleaningTime?: Maybe<Scalars['Int']>;
  totalOperation?: Maybe<Scalars['Int']>;
  usedStorage?: Maybe<Scalars['Int']>;
};

export type DeviceSettings = {
  __typename?: 'DeviceSettings';
  autoSideBroomSpeed?: Maybe<Scalars['Boolean']>;
  autoUpdate?: Maybe<Scalars['Boolean']>;
  batteryTheft: Scalars['Int'];
  beep: Scalars['Int'];
  blink: Scalars['Int'];
  cableDetection?: Maybe<Scalars['Boolean']>;
  carpetDetection?: Maybe<Scalars['Boolean']>;
  cleaningMode?: Maybe<CleaningSuctionEnum>;
  customerId?: Maybe<Scalars['ID']>;
  deviceId?: Maybe<Scalars['ID']>;
  firmwareUpdatedAt: Scalars['String'];
  firmwareVersion: Scalars['String'];
  hmiLanguage: Scalars['String'];
  lights: Scalars['Int'];
  password?: Maybe<Scalars['String']>;
  pinLock: Scalars['Int'];
  quickCleaningMode?: Maybe<Scalars['Boolean']>;
  soundOperating: Scalars['Int'];
  soundVolume: Scalars['Int'];
  soundWarning: Scalars['Int'];
  ssid?: Maybe<Scalars['String']>;
  theftProtection: Scalars['Int'];
};

export type DeviceSettingsInput = {
  autoSideBroomSpeed?: InputMaybe<Scalars['Boolean']>;
  autoUpdate?: InputMaybe<Scalars['Boolean']>;
  batteryTheft?: InputMaybe<Scalars['Int']>;
  beep?: InputMaybe<Scalars['Int']>;
  blink?: InputMaybe<Scalars['Int']>;
  cableDetection?: InputMaybe<Scalars['Boolean']>;
  carpetDetection?: InputMaybe<Scalars['Boolean']>;
  cleaningMode?: InputMaybe<CleaningSuctionEnum>;
  customerId?: InputMaybe<Scalars['ID']>;
  deviceId?: InputMaybe<Scalars['ID']>;
  firmwareUpdatedAt?: InputMaybe<Scalars['String']>;
  firmwareVersion?: InputMaybe<Scalars['String']>;
  hmiLanguage?: InputMaybe<Scalars['String']>;
  lights?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  pinLock?: InputMaybe<Scalars['Int']>;
  quickCleaningMode?: InputMaybe<Scalars['Boolean']>;
  soundOperating?: InputMaybe<Scalars['Int']>;
  soundVolume?: InputMaybe<Scalars['Int']>;
  soundWarning?: InputMaybe<Scalars['Int']>;
  ssid?: InputMaybe<Scalars['String']>;
  theftProtection?: InputMaybe<Scalars['Int']>;
};

export type DeviceSettingsUpdate = {
  __typename?: 'DeviceSettingsUpdate';
  autoSideBroomSpeed?: Maybe<Scalars['Boolean']>;
  autoUpdate?: Maybe<Scalars['Boolean']>;
  batteryTheft?: Maybe<Scalars['Int']>;
  beep?: Maybe<Scalars['Int']>;
  blink?: Maybe<Scalars['Int']>;
  cableDetection?: Maybe<Scalars['Boolean']>;
  carpetDetection?: Maybe<Scalars['Boolean']>;
  cleaningMode?: Maybe<CleaningSuctionEnum>;
  customerId?: Maybe<Scalars['ID']>;
  deviceId?: Maybe<Scalars['ID']>;
  firmwareUpdatedAt?: Maybe<Scalars['String']>;
  firmwareVersion?: Maybe<Scalars['String']>;
  hmiLanguage?: Maybe<Scalars['String']>;
  lights?: Maybe<Scalars['Int']>;
  password?: Maybe<Scalars['String']>;
  pinLock?: Maybe<Scalars['Int']>;
  quickCleaningMode?: Maybe<Scalars['Boolean']>;
  soundOperating?: Maybe<Scalars['Int']>;
  soundVolume?: Maybe<Scalars['Int']>;
  soundWarning?: Maybe<Scalars['Int']>;
  ssid?: Maybe<Scalars['String']>;
  theftProtection?: Maybe<Scalars['Int']>;
};

export type DeviceState = {
  __typename?: 'DeviceState';
  availability: DeviceStateAvailabilityEnum;
  batteries: Array<BatteryPack>;
  batteryPack1: BatteryPack;
  batteryPack2: BatteryPack;
  batterySystemChargeLevel: Scalars['Float'];
  cellularStatus: DeviceCellularStatus;
  charging: Scalars['Boolean'];
  consumables: DeviceStateConsumables;
  deviceState: DeviceStateEnum;
  docked: Scalars['Boolean'];
  location: DeviceLocation;
  mcuInfo: DeviceMcuInfo;
  paused: Scalars['Boolean'];
  waterLevel: Scalars['Int'];
  wifiStatus: DeviceWifiStatus;
};

export enum DeviceStateAvailabilityEnum {
  Offline = 'OFFLINE',
  Online = 'ONLINE'
}

export type DeviceStateConsumables = {
  __typename?: 'DeviceStateConsumables';
  brush?: Maybe<Scalars['Int']>;
  dirtContainer?: Maybe<Scalars['Int']>;
  filter?: Maybe<Scalars['Int']>;
  rubberLip?: Maybe<Scalars['Int']>;
  sensors?: Maybe<Scalars['Int']>;
  sideBroom?: Maybe<Scalars['Int']>;
};

export type DeviceStateConsumablesInput = {
  brush?: InputMaybe<Scalars['Int']>;
  dirtContainer?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<Scalars['Int']>;
  rubberLip?: InputMaybe<Scalars['Int']>;
  sensors?: InputMaybe<Scalars['Int']>;
  sideBroom?: InputMaybe<Scalars['Int']>;
};

export enum DeviceStateEnum {
  Boot = 'BOOT',
  Charging = 'CHARGING',
  Cleaning = 'CLEANING',
  CleaningMode = 'CLEANING_MODE',
  Docking = 'DOCKING',
  Driving = 'DRIVING',
  Error = 'ERROR',
  ErrorState = 'ERROR_STATE',
  Exploration = 'EXPLORATION',
  ExplorationMode = 'EXPLORATION_MODE',
  FlightMode = 'FLIGHT_MODE',
  Idle = 'IDLE',
  Localization = 'LOCALIZATION',
  Maintenance = 'MAINTENANCE',
  ManualCleaning = 'MANUAL_CLEANING',
  PathPlaning = 'PATH_PLANING',
  Pause = 'PAUSE',
  Sleep = 'SLEEP',
  Unknown = 'UNKNOWN',
  UpdateProcess = 'UPDATE_PROCESS',
  Waiting = 'WAITING',
  Warning = 'WARNING'
}

export type DeviceStateInput = {
  availability?: InputMaybe<DeviceStateAvailabilityEnum>;
  batteries?: InputMaybe<Array<InputMaybe<BatteryPackInput>>>;
  batteryPack1?: InputMaybe<BatteryPackInput>;
  batteryPack2?: InputMaybe<BatteryPackInput>;
  batterySystemChargeLevel?: InputMaybe<Scalars['Float']>;
  cellularStatus?: InputMaybe<DeviceCellularStatusInput>;
  charging?: InputMaybe<Scalars['Boolean']>;
  consumables?: InputMaybe<DeviceStateConsumablesInput>;
  deviceState?: InputMaybe<DeviceStateEnum>;
  docked?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<DeviceLocationInput>;
  mcuInfo?: InputMaybe<DeviceMcuInfoInput>;
  paused?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<DeviceStateEnum>;
  waterLevel?: InputMaybe<Scalars['Int']>;
  wifiStatus?: InputMaybe<DeviceWifiStatusInput>;
};

export type DeviceStateUpdate = {
  __typename?: 'DeviceStateUpdate';
  availability?: Maybe<DeviceStateAvailabilityEnum>;
  batteries?: Maybe<Array<Maybe<BatteryPackUpdate>>>;
  batteryPack1?: Maybe<BatteryPackUpdate>;
  batteryPack2?: Maybe<BatteryPackUpdate>;
  batterySystemChargeLevel?: Maybe<Scalars['Float']>;
  cellularStatus?: Maybe<DeviceCellularStatusUpdate>;
  charging?: Maybe<Scalars['Boolean']>;
  consumables?: Maybe<DeviceStateConsumables>;
  deviceState?: Maybe<DeviceStateEnum>;
  docked?: Maybe<Scalars['Boolean']>;
  mcuInfo?: Maybe<DeviceMcuInfoUpdate>;
  paused?: Maybe<Scalars['Boolean']>;
  waterLevel?: Maybe<Scalars['Int']>;
  wifiStatus?: Maybe<DeviceWifiStatusUpdate>;
};

export enum DeviceTaskStatusEnum {
  Done = 'DONE',
  Finished = 'FINISHED',
  InProgress = 'IN_PROGRESS',
  Paused = 'PAUSED',
  Preparing = 'PREPARING'
}

export enum DeviceTaskTypeEnum {
  Cleaning = 'CLEANING',
  NewMap = 'NEW_MAP'
}

export enum DeviceTypeName {
  Cv50 = 'CV50',
  Cv50V2 = 'CV50_V2',
  KiraB50 = 'KIRA_B50',
  KiraBd20 = 'KIRA_BD20',
  KiraBd50 = 'KIRA_BD50',
  KiraBd200 = 'KIRA_BD200',
  KiraBr50 = 'KIRA_BR50',
  KiraBr200 = 'KIRA_BR200',
  Unknown = 'UNKNOWN'
}

export type DeviceUpdate = {
  __typename?: 'DeviceUpdate';
  createdAt?: Maybe<Scalars['String']>;
  currentCleaningReport?: Maybe<CleaningReportUpdate>;
  customerId?: Maybe<Scalars['String']>;
  firmwareDetail?: Maybe<DeviceFirmwareDetailUpdate>;
  id?: Maybe<Scalars['ID']>;
  lastCleaningReport?: Maybe<CleaningReportUpdate>;
  lastOnline?: Maybe<Scalars['String']>;
  materialNumber?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nextScheduledTask?: Maybe<NextCleaningScheduleUpdate>;
  producedRobotId?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  settings?: Maybe<DeviceSettingsUpdate>;
  state?: Maybe<DeviceStateUpdate>;
  type?: Maybe<DeviceTypeName>;
  updateAvailable?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['String']>;
  wifiDetail?: Maybe<DeviceWifiNetworkDetailUpdate>;
};

export type DeviceWifiNetworkDetail = {
  __typename?: 'DeviceWifiNetworkDetail';
  ipv4Address: Scalars['String'];
  ipv6Address: Scalars['String'];
  macAddress: Scalars['String'];
  networkName: Scalars['String'];
  signalStrength: Scalars['Int'];
  subnetMask: Scalars['String'];
};

export type DeviceWifiNetworkDetailInput = {
  ipv4Address?: InputMaybe<Scalars['String']>;
  ipv6Address?: InputMaybe<Scalars['String']>;
  macAddress?: InputMaybe<Scalars['String']>;
  networkName?: InputMaybe<Scalars['String']>;
  signalStrength?: InputMaybe<Scalars['Int']>;
  subnetMask?: InputMaybe<Scalars['String']>;
};

export type DeviceWifiNetworkDetailUpdate = {
  __typename?: 'DeviceWifiNetworkDetailUpdate';
  ipv4Address?: Maybe<Scalars['String']>;
  ipv6Address?: Maybe<Scalars['String']>;
  macAddress?: Maybe<Scalars['String']>;
  networkName?: Maybe<Scalars['String']>;
  signalStrength?: Maybe<Scalars['Int']>;
  subnetMask?: Maybe<Scalars['String']>;
};

export type DeviceWifiStatus = {
  __typename?: 'DeviceWifiStatus';
  defaultGateway: Scalars['String'];
  ipv4Address: Scalars['String'];
  ipv6Address: Scalars['String'];
  macAddress: Scalars['String'];
  networkName: Scalars['String'];
  signalStrength: Scalars['Int'];
  subnetMask: Scalars['Int'];
};

export type DeviceWifiStatusInput = {
  defaultGateway?: InputMaybe<Scalars['String']>;
  ipv4Address?: InputMaybe<Scalars['String']>;
  ipv6Address?: InputMaybe<Scalars['String']>;
  macAddress?: InputMaybe<Scalars['String']>;
  networkName?: InputMaybe<Scalars['String']>;
  signalStrength?: InputMaybe<Scalars['Int']>;
  subnetMask?: InputMaybe<Scalars['Int']>;
};

export type DeviceWifiStatusUpdate = {
  __typename?: 'DeviceWifiStatusUpdate';
  defaultGateway?: Maybe<Scalars['String']>;
  ipv4Address?: Maybe<Scalars['String']>;
  ipv6Address?: Maybe<Scalars['String']>;
  macAddress?: Maybe<Scalars['String']>;
  networkName?: Maybe<Scalars['String']>;
  signalStrength?: Maybe<Scalars['Int']>;
  subnetMask?: Maybe<Scalars['Int']>;
};

export type DiscoveredWifis = {
  __typename?: 'DiscoveredWifis';
  mac: Scalars['String'];
  ss: Scalars['Int'];
  ssid: Scalars['String'];
};

export type EditMapGroupInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type FilterInput = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
};

export type FirmwareRelease = {
  __typename?: 'FirmwareRelease';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  identifier?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  materialNumber?: Maybe<Scalars['String']>;
  releasedAt?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

export type FirmwareReleases = {
  __typename?: 'FirmwareReleases';
  nodes: Array<FirmwareRelease>;
};

export type FirmwareUpdate = {
  __typename?: 'FirmwareUpdate';
  detail?: Maybe<Scalars['String']>;
  deviceId?: Maybe<Scalars['String']>;
  failureCause?: Maybe<Scalars['String']>;
  firmwareReleaseId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  materialNumber?: Maybe<Scalars['String']>;
  needApproval?: Maybe<Scalars['Boolean']>;
  progress?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  state: Scalars['String'];
  status?: Maybe<Scalars['String']>;
};

export type FirmwareUpdateResponse = {
  __typename?: 'FirmwareUpdateResponse';
  nodes?: Maybe<Array<Maybe<FirmwareUpdate>>>;
};

export type FirmwareUpdateSubscription = {
  __typename?: 'FirmwareUpdateSubscription';
  deviceId?: Maybe<Scalars['String']>;
  firmwareReleaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  materialNumber?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type FirmwareUpdateSubscriptionInput = {
  deviceId?: InputMaybe<Scalars['String']>;
  firmwareReleaseId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  materialNumber?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type GeneralCleaningCommandInput = {
  materialNumber: Scalars['String'];
  serialNumber: Scalars['String'];
};

export type GeneralCommandResponse = {
  __typename?: 'GeneralCommandResponse';
  successful: Scalars['Boolean'];
};

export type InvitationInfo = {
  __typename?: 'InvitationInfo';
  companyName: Scalars['String'];
  invitationCode: Scalars['String'];
  inviterName: Scalars['String'];
};

export type LocationActions = {
  __typename?: 'LocationActions';
  canCreate: Scalars['Boolean'];
  canView: Scalars['Boolean'];
};

export type MnsNsInput = {
  materialNumber: Scalars['String'];
  serialNumber: Scalars['String'];
};

export type Map = {
  __typename?: 'Map';
  active?: Maybe<Scalars['Boolean']>;
  associatedDevices: Array<Maybe<AssociatedDevices>>;
  createdAt?: Maybe<Scalars['String']>;
  creationMode?: Maybe<Scalars['String']>;
  customerId: Scalars['String'];
  deviceId: Scalars['String'];
  deviceType?: Maybe<Scalars['String']>;
  file?: Maybe<Scalars['String']>;
  fullPreview?: Maybe<Scalars['String']>;
  function?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  isNewMap?: Maybe<Scalars['Boolean']>;
  jsonData?: Maybe<PraMapJsonData>;
  lastUpdatedAt?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  mapGroupName?: Maybe<Scalars['String']>;
  materialNumber: Scalars['String'];
  name: Scalars['String'];
  permission?: Maybe<UserAssetPermission>;
  preview?: Maybe<Scalars['String']>;
  serialNumber: Scalars['String'];
  status?: Maybe<MapStatusEnum>;
  thumbnail?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  work?: Maybe<Scalars['String']>;
};

export type MapActions = {
  __typename?: 'MapActions';
  canAdd: Scalars['Boolean'];
};

export type MapEditor = {
  configContent?: InputMaybe<Scalars['String']>;
  eraseContent?: InputMaybe<Scalars['String']>;
  functionContent?: InputMaybe<Scalars['String']>;
  mapId: Scalars['ID'];
  revertEraseContent?: InputMaybe<Scalars['String']>;
  workContent?: InputMaybe<Scalars['String']>;
};

export type MapGroup = {
  __typename?: 'MapGroup';
  assignedMaps: Array<AssignedMaps>;
  id: Scalars['ID'];
  mapGroupCount: Scalars['Int'];
  name: Scalars['String'];
  permission?: Maybe<UserAssetPermission>;
};

export type MapGroupActions = {
  __typename?: 'MapGroupActions';
  canAdd: Scalars['Boolean'];
  mustSelectScope: Scalars['Boolean'];
};

export type MapGroupEdit = {
  __typename?: 'MapGroupEdit';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type MapGroups = {
  __typename?: 'MapGroups';
  nodes: Array<MapGroup>;
  pageInfo: PaginationMetadata;
};

export enum MapStatusEnum {
  Active = 'ACTIVE',
  Created = 'CREATED',
  Deleted = 'DELETED',
  Exploration = 'EXPLORATION',
  NewMap = 'NEW_MAP',
  Requested = 'REQUESTED'
}

export type Maps = {
  __typename?: 'Maps';
  nodes: Array<Map>;
  pageInfo: PaginationMetadata;
};

export type Membership = {
  __typename?: 'Membership';
  role: UserRole;
  scope: ScopeSummary;
};

export type MembershipInput = {
  roleId: Scalars['ID'];
  userIds: Array<Scalars['ID']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptInvitation: AcceptCustomerInvitation;
  addDevicesToGroup: SuccessfulResponse;
  assignDeviceGroupsToScope: SuccessfulResponse;
  assignMapGroupsToScope: SuccessfulResponse;
  assignUsersToScope: SuccessfulResponse;
  associateDevicesToMap: AssociateDevicesToMapResponse;
  associateMapsToGroup: AssociateMapsToGroupResponse;
  cancelInvitation: CustomerInvitation;
  changeBluetoothConnectivity: GeneralCommandResponse;
  changeDeviceLanguage: ChangeDeviceLanguage;
  changeDeviceName: ChangeDeviceName;
  changeDevicePin: ChangeDevicePin;
  changeDeviceSound: ChangeDeviceSound;
  changeFirmwareUpdateMode: ChangeFirmwareUpdateMode;
  changePassword: ChangePasswordResponse;
  claimDevice: ClaimedDevice;
  claimedDevice: ClaimDeviceSubscription;
  cleaningSchedule: CleaningScheduleUpdate;
  cleaningTask: RobotTaskUpdate;
  cleaningTaskProgress: RobotTaskProgressUpdate;
  cloneMap: CloneMapResponse;
  commandSend: CommandStatus;
  continueCleaning: GeneralCommandResponse;
  createCustomRole: CustomRole;
  createDeviceGroup: SuccessfulResponse;
  createInvitation: CustomerInvitation;
  createMapGroup: MapGroupEdit;
  createSchedule: CleaningScheduleV2;
  createScope: CreateScopeResponse;
  deleteCustomRole: SuccessfulResponse;
  deleteDeviceGroup: SuccessfulResponse;
  deleteMap: DeleteMapResponse;
  deleteMapGroup: DeleteMapGroupResponse;
  deleteSchedule: CleaningScheduleV2;
  deleteScope: SuccessfulResponse;
  device?: Maybe<DeviceUpdate>;
  deviceFirmwareUpdate: DeviceFirmwareUpdateSubscription;
  deviceGroups: DeviceGroupUpdate;
  deviceLocation: DeviceLocationUpdate;
  deviceMapPosition: DeviceMapPositionUpdate;
  editMapGroup: MapGroupEdit;
  firmwareUpdate: FirmwareUpdateSubscription;
  mapEditor: Map;
  mapGroups: PraSubMapGroups;
  maps: PraSubMaps;
  notification: NotificationUpdate;
  notificationRead: Notification;
  notificationReadAll: NotificationReadAllResponse;
  pauseCleaning: GeneralCommandResponse;
  permissionUpdate?: Maybe<PermissionUpdate>;
  publishScheduleChanged: CleaningScheduleV2;
  registerUser: RegisterUserResponse;
  removeCustomerUser: RemoveCustomerUser;
  removeDevice: RemoveDevice;
  removeDevicesFromGroup: SuccessfulResponse;
  restartFirmwareUpdate?: Maybe<RestartFirmwareUpdate>;
  sendBRangeCleaningCommand: GeneralCommandResponse;
  setScheduleActive: CleaningScheduleV2;
  setScopeName: SuccessfulResponse;
  setUserSubscriptions: PushNotificationMutationResponse;
  startCleaning: GeneralCommandResponse;
  startFirmwareUpdate?: Maybe<StartFirmwareUpdate>;
  startRemoteExploration: GeneralCommandResponse;
  stopCleaning: GeneralCommandResponse;
  unassociateDevicesToMap: UnassociateDevicesToMapResponse;
  unassociateMapsToGroup: UnassociateMapsToGroupResponse;
  unclaimDevice: UnclaimedDevice;
  unclaimedDevice: UnclaimDeviceSubscription;
  updateCustomRole: CustomRole;
  updateDeviceGroup: SuccessfulResponse;
  updateMap: Map;
  updateRolePermissions?: Maybe<Role>;
  updateSchedule: CleaningScheduleV2;
  user?: Maybe<UserUpdate>;
  userNotificationUpdate: UserNotification;
  validateInvitation: ValidateCustomerInvitation;
};


export type MutationAcceptInvitationArgs = {
  input: AcceptInvitationInput;
};


export type MutationAddDevicesToGroupArgs = {
  input: AddDevicesToGroupInput;
};


export type MutationAssignDeviceGroupsToScopeArgs = {
  input: AssignDeviceGroupsToScopeInput;
};


export type MutationAssignMapGroupsToScopeArgs = {
  input: AssignMapGroupsToScopeInput;
};


export type MutationAssignUsersToScopeArgs = {
  input: AssignUsersToScopeInput;
};


export type MutationAssociateDevicesToMapArgs = {
  input: AssociateDevicesToMapInput;
};


export type MutationAssociateMapsToGroupArgs = {
  input: AssociateMapsToGroupInput;
};


export type MutationCancelInvitationArgs = {
  id: Scalars['ID'];
};


export type MutationChangeBluetoothConnectivityArgs = {
  input: ChangeBluetoothConnectivityInput;
};


export type MutationChangeDeviceLanguageArgs = {
  input: ChangeDeviceLanguageInput;
};


export type MutationChangeDeviceNameArgs = {
  input: ChangeDeviceNameInput;
};


export type MutationChangeDevicePinArgs = {
  input: ChangeDevicePinInput;
};


export type MutationChangeDeviceSoundArgs = {
  input: ChangeDeviceSoundInput;
};


export type MutationChangeFirmwareUpdateModeArgs = {
  input: ChangeFirmwareUpdateModeInput;
};


export type MutationChangePasswordArgs = {
  input: ChangePasswordInput;
};


export type MutationClaimDeviceArgs = {
  input: ClaimDeviceInput;
};


export type MutationClaimedDeviceArgs = {
  input: ClaimDeviceSubscriptionInput;
};


export type MutationCleaningScheduleArgs = {
  input: CleaningScheduleInput;
};


export type MutationCleaningTaskArgs = {
  input: RobotTaskSubscriptionInput;
};


export type MutationCleaningTaskProgressArgs = {
  input: RobotTaskProgressSubscriptionInput;
};


export type MutationCloneMapArgs = {
  input: CloneMapInput;
};


export type MutationCommandSendArgs = {
  input: CommandSendInput;
};


export type MutationContinueCleaningArgs = {
  input: GeneralCleaningCommandInput;
};


export type MutationCreateCustomRoleArgs = {
  input: CreateCustomRoleInput;
};


export type MutationCreateDeviceGroupArgs = {
  input: CreateDeviceGroupInput;
};


export type MutationCreateInvitationArgs = {
  input: CreateInvitationInput;
};


export type MutationCreateMapGroupArgs = {
  input: CreateMapGroupInput;
};


export type MutationCreateScheduleArgs = {
  input: CreateScheduleInput;
};


export type MutationCreateScopeArgs = {
  input: CreateScopeInput;
};


export type MutationDeleteCustomRoleArgs = {
  input: DeleteCustomRoleInput;
};


export type MutationDeleteDeviceGroupArgs = {
  input: DeleteDeviceGroupInput;
};


export type MutationDeleteMapArgs = {
  input: DeleteMapInput;
};


export type MutationDeleteMapGroupArgs = {
  input: DeleteMapGroupInput;
};


export type MutationDeleteScheduleArgs = {
  input: DeleteScheduleInput;
};


export type MutationDeleteScopeArgs = {
  input: DeleteScopeInput;
};


export type MutationDeviceArgs = {
  input: DeviceInput;
};


export type MutationDeviceFirmwareUpdateArgs = {
  input: DeviceFirmwareUpdateSubscriptionInput;
};


export type MutationDeviceGroupsArgs = {
  input: DeviceGroupSubscriptionInput;
};


export type MutationDeviceLocationArgs = {
  input: DeviceLocationInput;
};


export type MutationDeviceMapPositionArgs = {
  input: DeviceMapPositionInput;
};


export type MutationEditMapGroupArgs = {
  input: EditMapGroupInput;
};


export type MutationFirmwareUpdateArgs = {
  input: FirmwareUpdateSubscriptionInput;
};


export type MutationMapEditorArgs = {
  input: MapEditor;
};


export type MutationMapGroupsArgs = {
  input: PraSubMapGroupInput;
};


export type MutationMapsArgs = {
  input: PraSubMapInput;
};


export type MutationNotificationArgs = {
  input: NotificationInput;
};


export type MutationNotificationReadArgs = {
  id: Scalars['ID'];
};


export type MutationPauseCleaningArgs = {
  input: GeneralCleaningCommandInput;
};


export type MutationPermissionUpdateArgs = {
  input: PermissionUpdateInput;
};


export type MutationPublishScheduleChangedArgs = {
  input: CleaningScheduleV2Input;
};


export type MutationRegisterUserArgs = {
  input: RegisterUserInput;
};


export type MutationRemoveCustomerUserArgs = {
  input: RemoveCustomerUserInput;
};


export type MutationRemoveDeviceArgs = {
  input: RemoveDeviceInput;
};


export type MutationRemoveDevicesFromGroupArgs = {
  input: RemoveDevicesFromGroupInput;
};


export type MutationRestartFirmwareUpdateArgs = {
  input: RestartFirmwareUpdateInput;
};


export type MutationSendBRangeCleaningCommandArgs = {
  input: BRangeCleaningCommandInput;
};


export type MutationSetScheduleActiveArgs = {
  input: SetScheduleActiveInput;
};


export type MutationSetScopeNameArgs = {
  input: SetScopeNameInput;
};


export type MutationSetUserSubscriptionsArgs = {
  input: SubscriptionInput;
};


export type MutationStartCleaningArgs = {
  input: StartCleaningCommandInput;
};


export type MutationStartFirmwareUpdateArgs = {
  input: StartFirmwareUpdateInput;
};


export type MutationStartRemoteExplorationArgs = {
  input: GeneralCleaningCommandInput;
};


export type MutationStopCleaningArgs = {
  input: StopCleaningCommandInput;
};


export type MutationUnassociateDevicesToMapArgs = {
  input: UnassociateDevicesToMapInput;
};


export type MutationUnassociateMapsToGroupArgs = {
  input: UnassociateMapsToGroupInput;
};


export type MutationUnclaimDeviceArgs = {
  input: UnclaimDeviceInput;
};


export type MutationUnclaimedDeviceArgs = {
  input: UnclaimDeviceSubscriptionInput;
};


export type MutationUpdateCustomRoleArgs = {
  input: UpdateCustomRoleInput;
};


export type MutationUpdateDeviceGroupArgs = {
  input: UpdateDeviceGroupInput;
};


export type MutationUpdateMapArgs = {
  input: UpdateMapInput;
};


export type MutationUpdateRolePermissionsArgs = {
  input: UpdateRolePermissionsInput;
};


export type MutationUpdateScheduleArgs = {
  input: UpdateScheduleInput;
};


export type MutationUserArgs = {
  input: UserInput;
};


export type MutationUserNotificationUpdateArgs = {
  input: UserNotificationUpdateInput;
};


export type MutationValidateInvitationArgs = {
  input: ValidateInvitationInput;
};

export type NetworkInfo = {
  __typename?: 'NetworkInfo';
  discoveredWifis: Array<DiscoveredWifis>;
  savedWifis: Array<SavedWifis>;
  updatedAt: Scalars['String'];
};

export type NextCleaningSchedule = {
  __typename?: 'NextCleaningSchedule';
  areaInSquareMeters: Scalars['Int'];
  cleaningDurationInSeconds: Scalars['Int'];
  cleaningZones?: Maybe<Array<Scalars['String']>>;
  deviceId: Scalars['String'];
  deviceName: Scalars['String'];
  id: Scalars['ID'];
  mapId: Scalars['String'];
  mapName: Scalars['String'];
  nextExecution: Scalars['String'];
  repetition: CleaningScheduleRepetitionEnum;
  startTime: Scalars['String'];
  suction: CleaningSuctionEnum;
  weekdays: Array<Scalars['Int']>;
};

export type NextCleaningScheduleInput = {
  areaInSquareMeters?: InputMaybe<Scalars['Int']>;
  cleaningDurationInSeconds?: InputMaybe<Scalars['Int']>;
  cleaningZones?: InputMaybe<Array<Scalars['String']>>;
  deviceId?: InputMaybe<Scalars['String']>;
  deviceName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  mapId?: InputMaybe<Scalars['String']>;
  mapName?: InputMaybe<Scalars['String']>;
  nextExecution?: InputMaybe<Scalars['String']>;
  repetition?: InputMaybe<CleaningScheduleRepetitionEnum>;
  startTime?: InputMaybe<Scalars['String']>;
  suction?: InputMaybe<CleaningSuctionEnum>;
  weekdays?: InputMaybe<Array<Scalars['Int']>>;
};

export type NextCleaningScheduleUpdate = {
  __typename?: 'NextCleaningScheduleUpdate';
  areaInSquareMeters?: Maybe<Scalars['Int']>;
  cleaningDurationInSeconds?: Maybe<Scalars['Int']>;
  cleaningZones?: Maybe<Array<Scalars['String']>>;
  deviceId?: Maybe<Scalars['String']>;
  deviceName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  mapId?: Maybe<Scalars['String']>;
  mapName?: Maybe<Scalars['String']>;
  nextExecution?: Maybe<Scalars['String']>;
  repetition?: Maybe<CleaningScheduleRepetitionEnum>;
  startTime?: Maybe<Scalars['String']>;
  suction?: Maybe<CleaningSuctionEnum>;
  weekdays?: Maybe<Array<Scalars['Int']>>;
};

export type Notification = {
  __typename?: 'Notification';
  active: Scalars['Int'];
  category: NotificationCategoryTypeEnum;
  code: Scalars['String'];
  createdAt: Scalars['String'];
  customerId: Scalars['String'];
  details?: Maybe<Scalars['String']>;
  deviceId?: Maybe<Scalars['String']>;
  deviceName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  materialNumber?: Maybe<Scalars['String']>;
  notificationType: NotificationTypeEnum;
  serialNumber?: Maybe<Scalars['String']>;
  severity: NotificationSeverityEnum;
  unread: Scalars['Int'];
  updatedAt: Scalars['String'];
};

export enum NotificationCategoryTypeEnum {
  CleaningTaskFinished = 'CLEANING_TASK_FINISHED',
  CleaningTaskInterrupted = 'CLEANING_TASK_INTERRUPTED',
  EmergencyStop = 'EMERGENCY_STOP',
  ErrorOccurred = 'ERROR_OCCURRED',
  Information = 'INFORMATION',
  InternalEvent = 'INTERNAL_EVENT',
  NotAssigned = 'NOT_ASSIGNED',
  NoWorkStart = 'NO_WORK_START',
  Resources = 'RESOURCES'
}

export type NotificationConnection = {
  __typename?: 'NotificationConnection';
  nodes: Array<Notification>;
  pageInfo: NotificationPaginationMetadata;
};

export type NotificationConnectionWithoutPaginationSettings = {
  __typename?: 'NotificationConnectionWithoutPaginationSettings';
  nodes: Array<Notification>;
};

export type NotificationInput = {
  active?: InputMaybe<Scalars['Int']>;
  category?: InputMaybe<NotificationCategoryTypeEnum>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['String']>;
  customerId: Scalars['String'];
  details?: InputMaybe<Scalars['String']>;
  deviceId?: InputMaybe<Scalars['String']>;
  deviceName?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  materialNumber?: InputMaybe<Scalars['String']>;
  notificationType?: InputMaybe<NotificationTypeEnum>;
  serialNumber?: InputMaybe<Scalars['String']>;
  severity?: InputMaybe<NotificationSeverityEnum>;
  unread?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type NotificationPaginationMetadata = {
  __typename?: 'NotificationPaginationMetadata';
  lastTimestamp: Scalars['String'];
  limit: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type NotificationReadAllResponse = {
  __typename?: 'NotificationReadAllResponse';
  successful: Scalars['Boolean'];
};

export enum NotificationSeverityEnum {
  Critical = 'CRITICAL',
  Info = 'INFO',
  Major = 'MAJOR',
  Minor = 'MINOR'
}

export enum NotificationStateEnum {
  Read = 'READ',
  Unread = 'UNREAD'
}

export enum NotificationTypeEnum {
  Device = 'DEVICE',
  User = 'USER'
}

export type NotificationUpdate = {
  __typename?: 'NotificationUpdate';
  active?: Maybe<Scalars['Int']>;
  category?: Maybe<NotificationCategoryTypeEnum>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['String']>;
  deviceId?: Maybe<Scalars['String']>;
  deviceName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  materialNumber?: Maybe<Scalars['String']>;
  notificationType?: Maybe<NotificationTypeEnum>;
  serialNumber?: Maybe<Scalars['String']>;
  severity?: Maybe<NotificationSeverityEnum>;
  unread?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export enum OrderDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
};

export type PaginationMetadata = {
  __typename?: 'PaginationMetadata';
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  order: Scalars['String'];
  orderBy: Scalars['String'];
  totalCount: Scalars['Int'];
};

export type PeriodInput = {
  endAt: Scalars['String'];
  startAt: Scalars['String'];
};

export enum PermissionEventType {
  MembershipAssigned = 'MEMBERSHIP_ASSIGNED',
  MembershipRemoved = 'MEMBERSHIP_REMOVED',
  RoleDeleted = 'ROLE_DELETED',
  RolePermissionsUpdated = 'ROLE_PERMISSIONS_UPDATED',
  ScopeAssetsUpdated = 'SCOPE_ASSETS_UPDATED',
  ScopeDeleted = 'SCOPE_DELETED'
}

export type PermissionUpdate = {
  __typename?: 'PermissionUpdate';
  customerId: Scalars['String'];
  eventType?: Maybe<PermissionEventType>;
  userId: Scalars['ID'];
};

export type PermissionUpdateInput = {
  customerId: Scalars['String'];
  eventType: PermissionEventType;
  userId: Scalars['ID'];
};

export type Permissions = {
  __typename?: 'Permissions';
  device: AssetPermissionEnum;
  deviceGroup: AssetPermissionEnum;
  map: AssetPermissionEnum;
  mapGroup: AssetPermissionEnum;
  user: AssetPermissionEnum;
};

export type PraMapContent = {
  __typename?: 'PraMapContent';
  config?: Maybe<Scalars['String']>;
  function?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  mapInfo?: Maybe<Scalars['String']>;
  work?: Maybe<Scalars['String']>;
};

export type PraMapContentInput = {
  config?: InputMaybe<Scalars['String']>;
  function?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  mapInfo?: InputMaybe<Scalars['String']>;
  work?: InputMaybe<Scalars['String']>;
};

export type PraMapJsonData = {
  __typename?: 'PraMapJsonData';
  date?: Maybe<Scalars['String']>;
  jsonContent?: Maybe<PraMapContent>;
  version?: Maybe<Scalars['Int']>;
};

export type PraMapJsonDataInput = {
  date?: InputMaybe<Scalars['String']>;
  jsonContent?: InputMaybe<PraMapContentInput>;
  version?: InputMaybe<Scalars['Int']>;
};

export type PraSubMapGroupInput = {
  customerId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type PraSubMapGroups = {
  __typename?: 'PraSubMapGroups';
  customerId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  mode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type PraSubMapInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  associatedDeviceMaterialNumber?: InputMaybe<Scalars['String']>;
  associatedDeviceSerialNumber?: InputMaybe<Scalars['String']>;
  associatedDevices?: InputMaybe<Array<InputMaybe<AssociatedDevicesInput>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  creationMode?: InputMaybe<Scalars['String']>;
  customerId: Scalars['String'];
  deviceId?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<Scalars['String']>;
  file?: InputMaybe<Scalars['String']>;
  fullPreview?: InputMaybe<Scalars['String']>;
  function?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  image?: InputMaybe<Scalars['String']>;
  isNewMap?: InputMaybe<Scalars['Boolean']>;
  jsonData?: InputMaybe<PraMapJsonDataInput>;
  lastUpdatedAt?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  mapGroupName?: InputMaybe<Scalars['String']>;
  materialNumber?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<MapStatusEnum>;
  thumbnail?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
  work?: InputMaybe<Scalars['String']>;
};

export type PraSubMaps = {
  __typename?: 'PraSubMaps';
  active?: Maybe<Scalars['Boolean']>;
  associatedDeviceMaterialNumber?: Maybe<Scalars['String']>;
  associatedDeviceSerialNumber?: Maybe<Scalars['String']>;
  associatedDevices?: Maybe<Array<Maybe<AssociatedDevices>>>;
  createdAt?: Maybe<Scalars['String']>;
  creationMode?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['String']>;
  deviceId?: Maybe<Scalars['String']>;
  deviceType?: Maybe<Scalars['String']>;
  file?: Maybe<Scalars['String']>;
  fullPreview?: Maybe<Scalars['String']>;
  function?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
  image?: Maybe<Scalars['String']>;
  isNewMap?: Maybe<Scalars['Boolean']>;
  jsonData?: Maybe<PraMapJsonData>;
  lastUpdatedAt?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  mapGroupName?: Maybe<Scalars['String']>;
  materialNumber?: Maybe<Scalars['String']>;
  mode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  status?: Maybe<MapStatusEnum>;
  thumbnail?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  work?: Maybe<Scalars['String']>;
};

export type PushNotificationMutationResponse = {
  __typename?: 'PushNotificationMutationResponse';
  successful: Scalars['Boolean'];
};

export type Query = {
  __typename?: 'Query';
  cleaningReport: CleaningReport;
  cleaningReportMap?: Maybe<CleaningReportMap>;
  cleaningReports: AllCleaningReports;
  cleaningSchedule: CleaningSchedule;
  cleaningScheduleOccurrences: Array<CleaningScheduleOccurrence>;
  cleaningSchedules: CleaningScheduleConnection;
  cleaningTask: RobotTask;
  cleaningTasks: RobotTasks;
  commandStatus: CommandStatus;
  customer: Customer;
  device: Device;
  deviceFirmwareUpdate: FirmwareUpdate;
  deviceFirmwareUpdates: Array<FirmwareUpdate>;
  deviceGroup: DeviceGroup;
  deviceGroups: DeviceGroups;
  deviceMapLocation: DeviceMapLocationConnection;
  devices: DeviceConnection;
  firmwareReleases: FirmwareReleases;
  firmwareUpdate: FirmwareUpdateResponse;
  invitation: CustomerInvitation;
  invitationInfo: InvitationInfo;
  invitations: ConnectedCustomerInvitation;
  map: Map;
  mapGroups: MapGroups;
  maps: Maps;
  networkInfo: NetworkInfo;
  notification: Notification;
  notifications: NotificationConnection;
  role: Role;
  roles: Roles;
  route: Route;
  routes: RouteConnection;
  routine: Routine;
  routines: RoutineConnection;
  schedule: CleaningScheduleV2;
  schedules: CleaningScheduleV2Connection;
  scope: ScopeDetail;
  scopes: Scopes;
  user: User;
  userCustomer: UserCustomer;
  userInfo?: Maybe<UserInfo>;
  userSubscriptions: CategorySubscriptionsQueryResponse;
  validateClaiming: ValidatedClaiming;
};


export type QueryCleaningReportArgs = {
  id: Scalars['ID'];
};


export type QueryCleaningReportMapArgs = {
  id: Scalars['ID'];
  materialNumber: Scalars['String'];
  serialNumber: Scalars['String'];
};


export type QueryCleaningReportsArgs = {
  activities?: InputMaybe<Array<CleaningActivityEnum>>;
  activity?: InputMaybe<CleaningActivityEnum>;
  cleaningGroupId?: InputMaybe<Scalars['String']>;
  cleaningGroupIds?: InputMaybe<Array<Scalars['String']>>;
  deviceType?: InputMaybe<DeviceTypeName>;
  deviceTypes?: InputMaybe<Array<DeviceTypeName>>;
  filter?: InputMaybe<FilterInput>;
  groupId?: InputMaybe<Scalars['String']>;
  groupIds?: InputMaybe<Array<Scalars['String']>>;
  mapId?: InputMaybe<Scalars['String']>;
  mapIds?: InputMaybe<Array<Scalars['String']>>;
  materialNumber?: InputMaybe<Scalars['String']>;
  materialNumbers?: InputMaybe<Array<Scalars['String']>>;
  reportType?: InputMaybe<Array<InputMaybe<CleaningReportTypeEnum>>>;
  routineId?: InputMaybe<Scalars['String']>;
  routineIds?: InputMaybe<Array<Scalars['String']>>;
  scopes?: InputMaybe<Array<CleaningScopeEnum>>;
  serialNumber?: InputMaybe<Scalars['String']>;
  serialNumbers?: InputMaybe<Array<Scalars['String']>>;
  status?: InputMaybe<CleaningStatusEnum>;
  statuses?: InputMaybe<Array<CleaningStatusEnum>>;
  time?: InputMaybe<CleaningReportTimeFilter>;
};


export type QueryCleaningScheduleArgs = {
  id: Scalars['ID'];
};


export type QueryCleaningScheduleOccurrencesArgs = {
  materialNumber: Scalars['String'];
  period: PeriodInput;
  serialNumber: Scalars['String'];
};


export type QueryCleaningTaskArgs = {
  id?: InputMaybe<Scalars['ID']>;
  materialNumber: Scalars['String'];
  serialNumber: Scalars['String'];
};


export type QueryCleaningTasksArgs = {
  filter?: InputMaybe<FilterInput>;
  materialNumber: Scalars['String'];
  serialNumber: Scalars['String'];
};


export type QueryCommandStatusArgs = {
  id: Scalars['ID'];
};


export type QueryDeviceArgs = {
  id?: InputMaybe<Scalars['ID']>;
  materialNumber?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
};


export type QueryDeviceFirmwareUpdateArgs = {
  materialNumber: Scalars['String'];
  serialNumber: Scalars['String'];
};


export type QueryDeviceFirmwareUpdatesArgs = {
  materialNumber: Scalars['String'];
  serialNumber: Scalars['String'];
};


export type QueryDeviceGroupArgs = {
  id: Scalars['ID'];
};


export type QueryDeviceGroupsArgs = {
  filter?: InputMaybe<FilterInput>;
};


export type QueryDeviceMapLocationArgs = {
  deviceId?: InputMaybe<Scalars['ID']>;
  filter?: InputMaybe<TimestampFilterInput>;
  materialNumber?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
};


export type QueryDevicesArgs = {
  availabilities?: InputMaybe<Array<InputMaybe<DeviceStateAvailabilityEnum>>>;
  dateOfClaim?: InputMaybe<Scalars['String']>;
  deviceStates?: InputMaybe<Array<InputMaybe<DeviceStateEnum>>>;
  deviceTypes?: InputMaybe<Array<InputMaybe<DeviceTypeName>>>;
  filter?: InputMaybe<FilterInput>;
  lastOnline?: InputMaybe<Scalars['String']>;
  materialNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  serialNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryFirmwareReleasesArgs = {
  deviceId?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<FilterInput>;
  materialNumber?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
};


export type QueryFirmwareUpdateArgs = {
  deviceId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  materialNumber?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
};


export type QueryInvitationArgs = {
  id: Scalars['ID'];
};


export type QueryInvitationInfoArgs = {
  invitationCode: Scalars['String'];
};


export type QueryInvitationsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['String']>;
};


export type QueryMapArgs = {
  id: Scalars['ID'];
};


export type QueryMapGroupsArgs = {
  filter?: InputMaybe<FilterInput>;
};


export type QueryMapsArgs = {
  deviceIds?: InputMaybe<Array<Scalars['String']>>;
  filter?: InputMaybe<FilterInput>;
  groupIds?: InputMaybe<Array<Scalars['String']>>;
  mnsns?: InputMaybe<Array<MnsNsInput>>;
};


export type QueryNetworkInfoArgs = {
  deviceInput: UniqueDeviceInput;
};


export type QueryNotificationArgs = {
  id: Scalars['ID'];
};


export type QueryNotificationsArgs = {
  categories?: InputMaybe<Array<NotificationCategoryTypeEnum>>;
  codes?: InputMaybe<Array<Scalars['String']>>;
  deviceId?: InputMaybe<Scalars['ID']>;
  deviceIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  deviceName?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<DeviceTypeName>;
  deviceTypes?: InputMaybe<Array<DeviceTypeName>>;
  filter?: InputMaybe<TimestampFilterInput>;
  materialNumber?: InputMaybe<Scalars['String']>;
  materialNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notificationTypes?: InputMaybe<Array<NotificationTypeEnum>>;
  serialNumber?: InputMaybe<Scalars['String']>;
  serialNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  severities?: InputMaybe<Array<NotificationSeverityEnum>>;
  states?: InputMaybe<Array<NotificationStateEnum>>;
};


export type QueryRoleArgs = {
  id: Scalars['ID'];
};


export type QueryRolesArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryRouteArgs = {
  id: Scalars['ID'];
};


export type QueryRoutesArgs = {
  after?: InputMaybe<Scalars['String']>;
  deviceId?: InputMaybe<Scalars['String']>;
  deviceTypes?: InputMaybe<Array<DeviceTypeName>>;
  first?: InputMaybe<Scalars['Int']>;
  materialNumber?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<RouteOrder>;
  serialNumber?: InputMaybe<Scalars['String']>;
};


export type QueryRoutineArgs = {
  id: Scalars['ID'];
};


export type QueryRoutinesArgs = {
  after?: InputMaybe<Scalars['String']>;
  anonymous?: InputMaybe<Scalars['Boolean']>;
  deviceId?: InputMaybe<Scalars['String']>;
  deviceTypes?: InputMaybe<Array<DeviceTypeName>>;
  first?: InputMaybe<Scalars['Int']>;
  materialNumber?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<RoutineOrder>;
  routeId?: InputMaybe<Scalars['Int']>;
  serialNumber?: InputMaybe<Scalars['String']>;
};


export type QueryScheduleArgs = {
  id: Scalars['ID'];
};


export type QuerySchedulesArgs = {
  after?: InputMaybe<Scalars['String']>;
  deviceId?: InputMaybe<Scalars['String']>;
  excludeExpired?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  mapId?: InputMaybe<Scalars['String']>;
  materialNumber?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<CleaningScheduleV2Order>;
  repeatId?: InputMaybe<Scalars['String']>;
  routineId?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<ScheduleType>;
};


export type QueryScopeArgs = {
  id: Scalars['ID'];
};


export type QueryUserArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryUserSubscriptionsArgs = {
  deviceToken: Scalars['String'];
};


export type QueryValidateClaimingArgs = {
  materialNumber: Scalars['String'];
  serialNumber: Scalars['String'];
};

export type RegisterUserInput = {
  academicTitle: Scalars['String'];
  companyOnboarding: CompanyOnboardingInput;
  country: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  firstName2?: InputMaybe<Scalars['String']>;
  language: Scalars['String'];
  lastName: Scalars['String'];
  lastName2?: InputMaybe<Scalars['String']>;
  mobileNumber: Scalars['String'];
  mobileNumberCountry: Scalars['String'];
  password: Scalars['String'];
  phoneNumber: Scalars['String'];
  phoneNumberCountry: Scalars['String'];
  preferredLanguage: Scalars['String'];
  title: Scalars['String'];
};

export type RegisterUserResponse = {
  __typename?: 'RegisterUserResponse';
  successful: Scalars['Boolean'];
};

export type RemoveCustomerUser = {
  __typename?: 'RemoveCustomerUser';
  successful: Scalars['Boolean'];
};

export type RemoveCustomerUserInput = {
  email: Scalars['String'];
};

export type RemoveDevice = {
  __typename?: 'RemoveDevice';
  successful: Scalars['Boolean'];
};

export type RemoveDeviceInput = {
  materialNumber: Scalars['String'];
  serialNumber: Scalars['String'];
};

export type RemoveDevicesFromGroupInput = {
  deviceIds: Array<Scalars['ID']>;
  groupId: Scalars['ID'];
};

export type RestartFirmwareUpdate = {
  __typename?: 'RestartFirmwareUpdate';
  successful?: Maybe<Scalars['Boolean']>;
};

export type RestartFirmwareUpdateInput = {
  id: Scalars['String'];
};

export type RobotTask = {
  __typename?: 'RobotTask';
  createdAt: Scalars['String'];
  estimatedEndTime?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  mapId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  progress?: Maybe<RobotTaskProgress>;
  remainingTime?: Maybe<Scalars['Int']>;
  startTime: Scalars['String'];
  status: DeviceTaskStatusEnum;
  subName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['String'];
};

export type RobotTaskProgress = {
  __typename?: 'RobotTaskProgress';
  cleanedArea?: Maybe<Scalars['Int']>;
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  progress: Scalars['Int'];
  remainingArea?: Maybe<Scalars['Int']>;
  remainingProgress: Scalars['Int'];
  remainingTime?: Maybe<Scalars['Int']>;
  step?: Maybe<Scalars['Int']>;
  stepCount?: Maybe<Scalars['Int']>;
  stepEstimatedEndTime?: Maybe<Scalars['String']>;
  updatedAt: Scalars['String'];
};

export type RobotTaskProgressSubscriptionInput = {
  cleanedArea?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['String']>;
  deviceTaskId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  progress?: InputMaybe<Scalars['Int']>;
  remainingArea?: InputMaybe<Scalars['Int']>;
  remainingProgress?: InputMaybe<Scalars['Int']>;
  remainingTime?: InputMaybe<Scalars['Int']>;
  step?: InputMaybe<Scalars['Int']>;
  stepCount?: InputMaybe<Scalars['Int']>;
  stepEstimatedEndTime?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type RobotTaskProgressUpdate = {
  __typename?: 'RobotTaskProgressUpdate';
  cleanedArea?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['String']>;
  deviceTaskId?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
  progress?: Maybe<Scalars['Int']>;
  remainingArea?: Maybe<Scalars['Int']>;
  remainingProgress?: Maybe<Scalars['Int']>;
  remainingTime?: Maybe<Scalars['Int']>;
  step?: Maybe<Scalars['Int']>;
  stepCount?: Maybe<Scalars['Int']>;
  stepEstimatedEndTime?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type RobotTaskSubscriptionInput = {
  createdAt?: InputMaybe<Scalars['String']>;
  deviceId?: InputMaybe<Scalars['String']>;
  estimatedEndTime?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  mapId?: InputMaybe<Scalars['String']>;
  materialNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  remainingTime?: InputMaybe<Scalars['Int']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<DeviceTaskStatusEnum>;
  subName?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type RobotTaskUpdate = {
  __typename?: 'RobotTaskUpdate';
  createdAt?: Maybe<Scalars['String']>;
  deviceId?: Maybe<Scalars['String']>;
  estimatedEndTime?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  mapId?: Maybe<Scalars['String']>;
  materialNumber?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  remainingTime?: Maybe<Scalars['Int']>;
  serialNumber?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
  status?: Maybe<DeviceTaskStatusEnum>;
  subName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type RobotTasks = {
  __typename?: 'RobotTasks';
  nodes: Array<RobotTask>;
  pageInfo: PaginationMetadata;
};

export type Role = {
  __typename?: 'Role';
  createdAt: Scalars['String'];
  customerId: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isReadOnly: Scalars['Boolean'];
  minUsers: Scalars['Int'];
  name: Scalars['String'];
  permissions: Permissions;
  roleCategory: RoleCategoryEnum;
  scopes?: Maybe<Array<Scalars['ID']>>;
  updatedAt: Scalars['String'];
  userAccessLevel: AssetPermissionEnum;
};

export enum RoleCategoryEnum {
  Custom = 'CUSTOM',
  Manager = 'MANAGER',
  Member = 'MEMBER',
  Restricted = 'RESTRICTED',
  Viewer = 'VIEWER'
}

export type RoleListItem = {
  __typename?: 'RoleListItem';
  createdAt: Scalars['String'];
  customerId: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isReadOnly: Scalars['Boolean'];
  name: Scalars['String'];
  roleCategory: RoleCategoryEnum;
  scopes: Array<Scalars['ID']>;
  updatedAt: Scalars['String'];
  userAccessLevel: AssetPermissionEnum;
};

export type RolePermissionsInput = {
  deviceGroupManagement: AssetPermissionEnum;
  deviceManagement: AssetPermissionEnum;
  mapGroupManagement: AssetPermissionEnum;
  mapManagement: AssetPermissionEnum;
  userManagement: AssetPermissionEnum;
};

export type Roles = {
  __typename?: 'Roles';
  nodes: Array<RoleListItem>;
};

export type Route = {
  __typename?: 'Route';
  createdAt: Scalars['String'];
  customerId: Scalars['String'];
  deviceId: Scalars['String'];
  duration?: Maybe<Scalars['String']>;
  endLandmark?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  materialNumber: Scalars['String'];
  name: Scalars['String'];
  postChargingDuration?: Maybe<Scalars['String']>;
  robotRouteId: Scalars['Int'];
  serialNumber: Scalars['String'];
  startLandmark?: Maybe<Scalars['String']>;
  thumbnailS3FilePath?: Maybe<Scalars['String']>;
  updatedAt: Scalars['String'];
};

export type RouteConnection = {
  __typename?: 'RouteConnection';
  nodes: Array<Maybe<Route>>;
  pageInfo: PageInfo;
};

export type RouteOrder = {
  direction: OrderDirection;
  field: RouteOrderField;
};

export enum RouteOrderField {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT'
}

export type Routine = {
  __typename?: 'Routine';
  anonymous: Scalars['Boolean'];
  createdAt: Scalars['String'];
  customerId: Scalars['String'];
  deviceId: Scalars['String'];
  duration?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  materialNumber: Scalars['String'];
  name: Scalars['String'];
  postChargingDuration?: Maybe<Scalars['String']>;
  robotRoutineId: Scalars['Int'];
  routeIds: Array<Scalars['Int']>;
  serialNumber: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type RoutineConnection = {
  __typename?: 'RoutineConnection';
  nodes: Array<Maybe<Routine>>;
  pageInfo: PageInfo;
};

export type RoutineOrder = {
  direction: OrderDirection;
  field: RoutineOrderField;
};

export enum RoutineOrderField {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT'
}

export type SavedWifis = {
  __typename?: 'SavedWifis';
  ssid: Scalars['String'];
  version: Scalars['Int'];
};

export enum ScheduleStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE'
}

export enum ScheduleSuctionEnum {
  Boost = 'BOOST',
  Eco = 'ECO',
  Normal = 'NORMAL'
}

export enum ScheduleType {
  KiraB = 'KIRA_B',
  KiraCv50 = 'KIRA_CV50'
}

export type Scope = {
  __typename?: 'Scope';
  createdAt: Scalars['String'];
  customerId: Scalars['String'];
  id: Scalars['ID'];
  isEMScope: Scalars['Boolean'];
  isGlobalScope: Scalars['Boolean'];
  name: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type ScopeDetail = {
  __typename?: 'ScopeDetail';
  assetPermission: AssetPermissionEnum;
  createdAt: Scalars['String'];
  deviceGroups: Array<ScopeDetailDeviceGroup>;
  isEMScope: Scalars['Boolean'];
  isGlobalScope: Scalars['Boolean'];
  mapGroups: Array<ScopeDetailMapGroup>;
  name: Scalars['String'];
  roles: Array<ScopeDetailRole>;
  scopeId: Scalars['ID'];
  updatedAt: Scalars['String'];
};

export type ScopeDetailDevice = {
  __typename?: 'ScopeDetailDevice';
  assetPermission: AssetPermissionEnum;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ScopeDetailDeviceGroup = {
  __typename?: 'ScopeDetailDeviceGroup';
  assetPermission: AssetPermissionEnum;
  devices: Array<ScopeDetailDevice>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ScopeDetailMap = {
  __typename?: 'ScopeDetailMap';
  assetPermission: AssetPermissionEnum;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ScopeDetailMapGroup = {
  __typename?: 'ScopeDetailMapGroup';
  assetPermission: AssetPermissionEnum;
  id: Scalars['ID'];
  maps: Array<ScopeDetailMap>;
  name: Scalars['String'];
};

export type ScopeDetailRole = {
  __typename?: 'ScopeDetailRole';
  assetPermission: AssetPermissionEnum;
  id: Scalars['ID'];
  name: Scalars['String'];
  roleCategory: RoleCategoryEnum;
  users: Array<ScopeDetailUser>;
};

export type ScopeDetailUser = {
  __typename?: 'ScopeDetailUser';
  assetPermission: AssetPermissionEnum;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ScopeDevice = {
  __typename?: 'ScopeDevice';
  id: Scalars['ID'];
  materialNumber: Scalars['String'];
  name: Scalars['String'];
  serialNumber: Scalars['String'];
};

export type ScopeDeviceGroup = {
  __typename?: 'ScopeDeviceGroup';
  devices: Array<ScopeDevice>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ScopeListItem = {
  __typename?: 'ScopeListItem';
  assetPermission: AssetPermissionEnum;
  createdAt: Scalars['String'];
  isEMScope: Scalars['Boolean'];
  isGlobalScope: Scalars['Boolean'];
  name: Scalars['String'];
  roles: Array<ScopeRoleStats>;
  scopeId: Scalars['ID'];
  updatedAt: Scalars['String'];
  userCount: Scalars['Int'];
};

export type ScopeMap = {
  __typename?: 'ScopeMap';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ScopeMapGroup = {
  __typename?: 'ScopeMapGroup';
  id: Scalars['ID'];
  maps: Array<ScopeMap>;
  name: Scalars['String'];
};

export type ScopeMembership = {
  __typename?: 'ScopeMembership';
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  roleId: Scalars['ID'];
  roleName: Scalars['String'];
  userEmail: Scalars['String'];
  userId: Scalars['ID'];
};

export type ScopeRoleStats = {
  __typename?: 'ScopeRoleStats';
  name: Scalars['String'];
  roleId: Scalars['ID'];
};

export type ScopeSummary = {
  __typename?: 'ScopeSummary';
  customerId: Scalars['String'];
  id: Scalars['ID'];
  isEMScope?: Maybe<Scalars['Boolean']>;
  isGlobalScope?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
};

export type Scopes = {
  __typename?: 'Scopes';
  nodes: Array<ScopeListItem>;
};

export type SetScheduleActiveInput = {
  active: Scalars['Boolean'];
  id: Scalars['String'];
};

export type SetScopeNameInput = {
  name: Scalars['String'];
  scopeId: Scalars['ID'];
};

export type ShortUser = {
  __typename?: 'ShortUser';
  assetPermission: AssetPermissionEnum;
  customerId: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
};

export type StartCleaningCommandInput = {
  cleaningZones?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mapId: Scalars['String'];
  materialNumber: Scalars['String'];
  mode?: InputMaybe<CleaningSuctionEnum>;
  preset?: InputMaybe<Scalars['String']>;
  serialNumber: Scalars['String'];
  spot?: InputMaybe<CleaningSpotInput>;
};

export type StartFirmwareUpdate = {
  __typename?: 'StartFirmwareUpdate';
  successful?: Maybe<Scalars['Boolean']>;
};

export type StartFirmwareUpdateInput = {
  materialNumber: Scalars['String'];
  serialNumber: Scalars['String'];
};

export type StopCleaningCommandInput = {
  materialNumber: Scalars['String'];
  serialNumber: Scalars['String'];
  shouldReturnHome: Scalars['Boolean'];
};

export type Subscription = {
  __typename?: 'Subscription';
  claimedDevice?: Maybe<ClaimDeviceSubscription>;
  cleaningSchedule?: Maybe<CleaningScheduleUpdate>;
  cleaningTask?: Maybe<RobotTaskUpdate>;
  cleaningTaskProgress?: Maybe<RobotTaskProgressUpdate>;
  device?: Maybe<DeviceUpdate>;
  deviceFirmwareUpdate?: Maybe<DeviceFirmwareUpdateSubscription>;
  deviceGroups: DeviceGroupUpdate;
  deviceLocation?: Maybe<DeviceLocationUpdate>;
  deviceMapPosition?: Maybe<DeviceMapPositionUpdate>;
  firmwareUpdate?: Maybe<FirmwareUpdateSubscription>;
  mapGroups: PraSubMapGroups;
  maps?: Maybe<PraSubMaps>;
  notification?: Maybe<NotificationUpdate>;
  permissionUpdate?: Maybe<PermissionUpdate>;
  scheduleChanged?: Maybe<CleaningScheduleV2>;
  unclaimedDevice?: Maybe<UnclaimDeviceSubscription>;
  user?: Maybe<UserUpdate>;
};


export type SubscriptionClaimedDeviceArgs = {
  customerId: Scalars['String'];
  deviceId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  materialNumber?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
};


export type SubscriptionCleaningScheduleArgs = {
  customerId: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  mapId?: InputMaybe<Scalars['String']>;
  materialNumber?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
};


export type SubscriptionCleaningTaskArgs = {
  materialNumber: Scalars['String'];
  serialNumber: Scalars['String'];
};


export type SubscriptionCleaningTaskProgressArgs = {
  deviceTaskId: Scalars['String'];
};


export type SubscriptionDeviceArgs = {
  customerId: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  materialNumber?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
};


export type SubscriptionDeviceFirmwareUpdateArgs = {
  customerId: Scalars['String'];
  id: Scalars['ID'];
};


export type SubscriptionDeviceGroupsArgs = {
  customerId: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
};


export type SubscriptionDeviceLocationArgs = {
  deviceId: Scalars['ID'];
};


export type SubscriptionDeviceMapPositionArgs = {
  deviceId: Scalars['ID'];
  materialNumber?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
};


export type SubscriptionFirmwareUpdateArgs = {
  deviceId?: InputMaybe<Scalars['String']>;
  firmwareReleaseId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  materialNumber?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
};


export type SubscriptionMapGroupsArgs = {
  customerId: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
};


export type SubscriptionMapsArgs = {
  associatedDeviceMaterialNumber?: InputMaybe<Scalars['String']>;
  associatedDeviceSerialNumber?: InputMaybe<Scalars['String']>;
  customerId: Scalars['String'];
  deviceId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};


export type SubscriptionNotificationArgs = {
  customerId: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  materialNumber?: InputMaybe<Scalars['String']>;
  notificationId?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
};


export type SubscriptionPermissionUpdateArgs = {
  customerId: Scalars['String'];
  userId: Scalars['ID'];
};


export type SubscriptionScheduleChangedArgs = {
  deviceId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  mapId?: InputMaybe<Scalars['String']>;
  materialNumber?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
};


export type SubscriptionUnclaimedDeviceArgs = {
  customerId?: InputMaybe<Scalars['String']>;
  deviceId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  materialNumber?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
};


export type SubscriptionUserArgs = {
  customerId: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
};

export type SubscriptionInput = {
  categories: Array<NotificationCategoryTypeEnum>;
  deviceToken: Scalars['String'];
};

export enum SubscriptionMode {
  Delete = 'DELETE',
  Insert = 'INSERT',
  Update = 'UPDATE',
  Upsert = 'UPSERT'
}

export type SuccessfulResponse = {
  __typename?: 'SuccessfulResponse';
  successful: Scalars['Boolean'];
};

export type TimestampFilterInput = {
  lastTimestamp?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};

export type UnassociateDevicesToMapInput = {
  id: Scalars['ID'];
  unassociatedDevices: Array<AssociatedDevicesInput>;
};

export type UnassociateDevicesToMapResponse = {
  __typename?: 'UnassociateDevicesToMapResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type UnassociateMapsToGroupInput = {
  id: Scalars['ID'];
  mapIds: Array<Scalars['ID']>;
};

export type UnassociateMapsToGroupResponse = {
  __typename?: 'UnassociateMapsToGroupResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type UnclaimDeviceInput = {
  materialNumber: Scalars['String'];
  serialNumber: Scalars['String'];
};

export type UnclaimDeviceSubscription = {
  __typename?: 'UnclaimDeviceSubscription';
  customerId?: Maybe<Scalars['String']>;
  deviceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  materialNumber?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
};

export type UnclaimDeviceSubscriptionInput = {
  customerId: Scalars['String'];
  deviceId: Scalars['String'];
  id: Scalars['ID'];
  materialNumber: Scalars['String'];
  serialNumber: Scalars['String'];
};

export type UnclaimedDevice = {
  __typename?: 'UnclaimedDevice';
  deleted: Scalars['Boolean'];
};

export type UniqueDeviceInput = {
  materialNumber: Scalars['String'];
  serialNumber: Scalars['String'];
};

export type UpdateCustomRoleInput = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<RolePermissionsInput>;
  roleId: Scalars['ID'];
};

export type UpdateDeviceGroupInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateMapInput = {
  associatedDevices?: InputMaybe<Array<InputMaybe<AssociatedDevicesInput>>>;
  groupId?: InputMaybe<Scalars['String']>;
  mapId: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateRolePermissionsInput = {
  deviceGroupManagement?: InputMaybe<AssetPermissionEnum>;
  deviceManagement?: InputMaybe<AssetPermissionEnum>;
  mapGroupManagement?: InputMaybe<AssetPermissionEnum>;
  mapManagement?: InputMaybe<AssetPermissionEnum>;
  roleId: Scalars['ID'];
  userManagement?: InputMaybe<AssetPermissionEnum>;
};

export type UpdateScheduleInput = {
  applyToFollowing?: InputMaybe<Scalars['Boolean']>;
  cleaningZones?: InputMaybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  mapId?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  occurrence?: InputMaybe<Scalars['String']>;
  routeId?: InputMaybe<Scalars['ID']>;
  routineId?: InputMaybe<Scalars['ID']>;
  rrule: Scalars['String'];
  suction?: InputMaybe<CleaningSuctionEnum>;
};

export type User = {
  __typename?: 'User';
  customerId: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  memberships: Array<Membership>;
  userActions: UserActions;
};

export type UserActions = {
  __typename?: 'UserActions';
  device: DeviceActions;
  deviceGroup: DeviceGroupActions;
  location: LocationActions;
  map: MapActions;
  mapGroup: MapGroupActions;
  user: UserManagementActions;
};

export type UserAssetPermission = {
  __typename?: 'UserAssetPermission';
  assetPermission: AssetPermissionEnum;
};

export type UserCustomer = {
  __typename?: 'UserCustomer';
  createdAt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['String']>;
  users: Array<ShortUser>;
};

export type UserGroup = {
  __typename?: 'UserGroup';
  createdAt?: Maybe<Scalars['String']>;
  customerId: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['String']>;
};

export type UserInfo = {
  __typename?: 'UserInfo';
  customerId: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  memberships: Array<Membership>;
  userActions: UserActions;
  userId: Scalars['String'];
};

export type UserInput = {
  customerId: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: InputMaybe<Scalars['String']>;
};

export type UserManagementActions = {
  __typename?: 'UserManagementActions';
  canInvite: Scalars['Boolean'];
  canRemove: Scalars['Boolean'];
  canView: Scalars['Boolean'];
  mustSelectScope: Scalars['Boolean'];
};

export type UserNotification = {
  __typename?: 'UserNotification';
  deviceToken: Scalars['String'];
  language: Scalars['String'];
};

export type UserNotificationUpdateInput = {
  deviceToken: Scalars['String'];
  language: Scalars['String'];
};

export type UserRole = {
  __typename?: 'UserRole';
  customerId: Scalars['String'];
  id: Scalars['ID'];
  isReadOnly: Scalars['Boolean'];
  isRemoveAble: Scalars['Boolean'];
  name: Scalars['String'];
  roleCategory?: Maybe<RoleCategoryEnum>;
};

export type UserUpdate = {
  __typename?: 'UserUpdate';
  customerId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  lastName?: Maybe<Scalars['String']>;
};

export type ValidateCustomerInvitation = {
  __typename?: 'ValidateCustomerInvitation';
  successful: Scalars['Boolean'];
};

export type ValidateInvitationInput = {
  force?: InputMaybe<Scalars['Boolean']>;
  invitationCode: Scalars['String'];
};

export type ValidatedClaiming = {
  __typename?: 'ValidatedClaiming';
  deviceType?: Maybe<DeviceTypeName>;
  validationResult: ClaimingValidationResultEnum;
};
